// Mock data for Profinoks home page clone - Updated 2024-04-30 v2
// All content here is static and not loaded from any backend API.

export const sliderItems = [
  { id: 1, title: "", imageUrl: "/profinoks/hero/hero-1.jpg" },
  { id: 2, title: "", imageUrl: "/profinoks/hero/hero-2.jpg" },
  { id: 3, title: "", imageUrl: "/profinoks/hero/hero-3.jpg" },
  { id: 4, title: "", imageUrl: "/profinoks/hero/hero-4.jpg" },
  { id: 5, title: "", imageUrl: "/profinoks/hero/hero-5.jpg" },
  { id: 6, title: "", imageUrl: "/profinoks/hero/hero-6.jpg" },
  { id: 7, title: "", imageUrl: "/profinoks/hero/hero-7.jpg" },
  { id: 8, title: "", imageUrl: "/profinoks/hero/hero-8.jpg" },
  { id: 9, title: "", imageUrl: "/profinoks/hero/hero-9.jpg" },
  { id: 10, title: "", imageUrl: "/profinoks/hero/hero-10.jpg" },
];

export const productGroups = [
  { 
    id: 1, 
    title_tr: "PİŞİRİCİLER", 
    title_en: "COOKING EQUIPMENT",
    slug: "pisiriciler", 
    imageUrl: "/profinoks/products/pisiriciler.jpg", 
    href: "/products/pisiriciler", 
    description_tr: "Gazlı ve elektrikli yer ocakları, devrilir tavalar, kuzine fırınlar ve ızgaralar.",
    description_en: "Gas and electric boiling tops, tilting pans, range ovens and grills.",
    subCategories: [
      { title_tr: "Seri 700 Pişirme Ekipmanları", title_en: "Series 700 Cooking Equipment", slug: "seri-700-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-700-cover.jpg" },
      { title_tr: "Seri 730 Pişirme Ekipmanları", title_en: "Series 730 Cooking Equipment", slug: "seri-730-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-730-cover.jpg" },
      { title_tr: "Seri 900 Pişirme Ekipmanları", title_en: "Series 900 Cooking Equipment", slug: "seri-900-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-900-cover.jpg" },
      { title_tr: "Seri E 600 Pişirme Ekipmanları", title_en: "Series E 600 Cooking Equipment", slug: "seri-e-600-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-e-600-cover.jpg" },
    ]
  },
  { 
    id: 2, 
    title_tr: "FIRINLAR", 
    title_en: "OVENS",
    slug: "firinlar", 
    imageUrl: "/profinoks/products/firinlar.jpg", 
    href: "/products/firinlar", 
    description_tr: "Gazlı pasta börek fırınları ve çeşitli endüstriyel fırınlar.",
    description_en: "Gas pastry ovens and various industrial ovens.",
    subCategories: [
      { title_tr: "Electrolux Professional Fırınlar", title_en: "Electrolux Professional Ovens", slug: "electrolux-firinlar", imageUrl: "/profinoks/products/firinlar/electrolux-professional-firinlar.jpg" },
      { title_tr: "Empero Fırınlar", title_en: "Empero Ovens", slug: "empero-firinlar", imageUrl: "/profinoks/products/firinlar/empero-firinlar.jpg" },
      { title_tr: "Rational Fırınlar", title_en: "Rational Ovens", slug: "rational-firinlar", imageUrl: "/profinoks/products/firinlar/rational-firinlar.jpg" },
      { title_tr: "Unox Fırınlar", title_en: "Unox Ovens", slug: "unox-firinlar", imageUrl: "/profinoks/products/firinlar/unox-firinlar.jpg" },
      { title_tr: "Vital Fırınlar", title_en: "Vital Ovens", slug: "vital-firinlar", imageUrl: "/profinoks/products/firinlar/vital-firinlar.jpg" },
      { title_tr: "Zanussi Professional Fırınlar", title_en: "Zanussi Professional Ovens", slug: "zanussi-professional-firinlar", imageUrl: "/profinoks/products/firinlar/Zanussi-Professional-firinlar.jpg" },
      { title_tr: "Öztiryakiler Fırınlar", title_en: "Oztiryakiler Ovens", slug: "oztiryakiler-firinlar", imageUrl: "/profinoks/products/firinlar/oztiryakiler-firinlar.jpg" },
      { title_tr: "İnoksan Fırınlar", title_en: "Inoksan Ovens", slug: "inoksan-firinlar", imageUrl: "/profinoks/products/firinlar/inoksan-firinlar.jpg" },
    ]
  },
  { 
    id: 3, 
    title_tr: "BULAŞIK MAKİNELERİ", 
    title_en: "DISHWASHERS",
    slug: "bulasik-makineleri", 
    imageUrl: "/profinoks/products/bulasik-makineleri.jpg", 
    href: "/products/bulasik-makineleri", 
    description_tr: "Endüstriyel bulaşık yıkama çözümleri.",
    description_en: "Industrial dishwashing solutions.",
    subCategories: [
      { title_tr: "Giyotin Tip Bulaşık Makineleri", title_en: "Hood Type Dishwashers", slug: "giyotin-tip-bulasik-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Giyotin Tip Bulaşık Makineleri/505089_Giyotin_Tip_Bulaşık_Yıkama_Makinesi.jpg" },
      { title_tr: "Konveyörlü Bulaşık Yıkama Makineleri", title_en: "Conveyor Dishwashers", slug: "konveyorlu-bulasik-yikama-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Konveyörlü Bulaşık Yıkama Makineleri/BKE2000L_Konveyörlü_Bulaşık_Yıkama_Makinesi_-_Sol_Girişli.png" },
      { title_tr: "Set Altı Bardak Yıkama Makineleri", title_en: "Undercounter Glasswashers", slug: "set-alti-bardak-yikama-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Set Altı Bardak Yıkama Makineleri/402278_Set_Altı_Bardak_Yıkama_Makinesi.jpg" },
      { title_tr: "Set Altı Bulaşık Yıkama Makineleri", title_en: "Undercounter Dishwashers", slug: "set-alti-bulasik-yikama-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Set Altı Bulaşık Yıkama Makineleri/400257_Set_Altı_Bulaşık_Yıkama_Makinesi.jpg" }
    ]
  },
  { 
    id: 4, 
    title_tr: "HAZIRLIK MAKİNELERİ", 
    title_en: "PREPARATION MACHINES",
    slug: "hazirlik-makineleri", 
    imageUrl: "/profinoks/products/hazirlik-makineleri.jpg", 
    href: "/products/hazirlik-makineleri", 
    description_tr: "Mutfak hazırlık süreçleri için yardımcı ekipmanlar.",
    description_en: "Auxiliary equipment for kitchen preparation processes.",
    subCategories: [
      { title_tr: "Adana Kebap Makineleri", title_en: "Adana Kebab Machines", slug: "adana-kebap-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/adana-kebap-makineleri/3001.jpg" },
      { title_tr: "Bulama ve Paneleme Makineleri", title_en: "Breading and Battering Machines", slug: "bulama-ve-paneleme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/bulama-ve-paneleme-makineleri/3002.jpg" },
      { title_tr: "Ekmek Dilimleme Makineleri", title_en: "Bread Slicing Machines", slug: "ekmek-dilimleme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/ekmek-dilimleme-makineleri/3003.jpg" },
      { title_tr: "El Blenderları", title_en: "Hand Blenders", slug: "el-blenderlari", imageUrl: "/profinoks/products/hazirlik-makineleri/el-blenderlari/3013.jpg" },
      { title_tr: "Et Kıyma Makineleri", title_en: "Meat Grinders", slug: "et-kiyma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/et-kiyma-makineleri/3060.jpg" },
      { title_tr: "Et ve Kemik Testereleri", title_en: "Meat and Bone Saws", slug: "et-ve-kemik-testereleri", imageUrl: "/profinoks/products/hazirlik-makineleri/et-ve-kemik-testereleri/3102.jpg" },
      { title_tr: "Gıda Dilimleme Makineleri", title_en: "Food Slicing Machines", slug: "gida-dilimleme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/gida-dilimleme-makineleri/3106.jpg" },
      { title_tr: "Gıda Öğütücüleri", title_en: "Food Grinding Machines", slug: "gida-ogutuculeri", imageUrl: "/profinoks/products/hazirlik-makineleri/gida-ogutuculeri/3113.jpg" },
      { title_tr: "Hamur Açma Makineleri", title_en: "Dough Sheeters", slug: "hamur-acma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/hamur-acma-makineleri/3120.jpg" },
      { title_tr: "Hamur Yoğurma Makineleri", title_en: "Dough Kneading Machines", slug: "hamur-yogurma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/hamur-yogurma-makineleri/3125.jpg" },
      { title_tr: "Köfte Şekillendirme Makineleri", title_en: "Meatball Forming Machines", slug: "kofte-sekillendirme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/kofte-sekillendirme-makineleri/3169.jpg" },
      { title_tr: "Lokma Dökme Makineleri", title_en: "Lokma Doughnut Machines", slug: "lokma-dokme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/lokma-dokme-makineleri/3170.jpeg" },
      { title_tr: "Otomatik Fritözler", title_en: "Automatic Fryers", slug: "otomatik-fritozler", imageUrl: "/profinoks/products/hazirlik-makineleri/otomatik-fritozler/3172.png" },
      { title_tr: "Patates Dilimleme Makinesi", title_en: "Potato Slicing Machine", slug: "patates-dilimleme-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/1771948463019_pw7myv.png" },
      { title_tr: "Patates Soyma Makineleri", title_en: "Potato Peeling Machines", slug: "patates-soyma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/patates-soyma-makineleri/3174.jpg" },
      { title_tr: "Planet Mikserler", title_en: "Planetary Mixers", slug: "planet-mikserler", imageUrl: "/profinoks/products/hazirlik-makineleri/planet-mikserler/3200.jpg" },
      { title_tr: "Sebze Doğrama Makineleri", title_en: "Vegetable Cutting Machines", slug: "sebze-dograma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/sebze-dograma-makineleri/3234.jpg" },
      { title_tr: "Sebze Yıkama ve Kurutma Makineleri", title_en: "Vegetable Washing and Drying Machines", slug: "sebze-yikama-ve-kurutma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/sebze-yikama-ve-kurutma-makineleri/3292.jpg" },
      { title_tr: "Sebze-Et Parçalama Makineleri", title_en: "Vegetable and Meat Shredders", slug: "sebze-et-parcalama-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/sebze-et-parcalama-makineleri/3309.jpg" },
      { title_tr: "Soğan Doğrama Makinesi", title_en: "Onion Cutting Machine", slug: "sogan-dograma-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/sogan-dograma-makinesi/13203.jpg" },
      { title_tr: "Spiral Hamur Yoğurma Makineleri", title_en: "Spiral Dough Kneaders", slug: "spiral-hamur-yogurma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/spiral-hamur-yogurma-makineleri/3339.jpg" },
      { title_tr: "Tabak Kapatma Makinesi", title_en: "Plate Sealing Machine", slug: "tabak-kapatma-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/tabak-kapatma-makinesi/13200.jpg" },
      { title_tr: "Tavuk Kesme Makinesi", title_en: "Chicken Cutting Machine", slug: "tavuk-kesme-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/tavuk-kesme-makinesi/3345.jpeg" },
      { title_tr: "Tulumba ve Köfte Şekillendirme Makineleri", title_en: "Pastry and Meatball Forming Machines", slug: "tulumba-ve-kofte-sekillendirme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/tulumba-ve-kofte-sekillendirme-makineleri/3346.jpg" },
      { title_tr: "Çekmeceli Isıtma Üniteleri", title_en: "Drawer Heating Units", slug: "cekmeceli-isitma-uniteleri", imageUrl: "/profinoks/products/hazirlik-makineleri/cekmeceli-isitma-uniteleri/3350.jpg" },
    ]
  },
  { 
    id: 5, 
    title_tr: "İÇECEK MAKİNELERİ", 
    title_en: "BEVERAGE MACHINES",
    slug: "icecek-makineleri", 
    imageUrl: "/profinoks/products/icecek-makineleri.jpg", 
    href: "/products/icecek-makineleri", 
    description_tr: "Çay, kahve ve soğuk içecek hazırlama makineleri.",
    description_en: "Tea, coffee and cold beverage preparation machines.",
    subCategories: [
      { title_tr: "Bardak Fincan Isıtıcılar", title_en: "Cup and Mug Warmers", slug: "bardak-fincan-isiticilar", imageUrl: "/profinoks/products/icecek-makineleri/bardak-fincan-isiticilar/BFI60 - BARDAK FİNCAN ISITICI.jpg" },
      { title_tr: "Espresso Kahve Makineleri", title_en: "Espresso Coffee Machines", slug: "espresso-kahve-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/espresso-kahve-makineleri/Coffee Master Profesyonel Otomatik Espresso Kahve Makinesi - CRM3120 - cm1.jpg" },
      { title_tr: "Filtre Kahve Makineleri", title_en: "Filter Coffee Machines", slug: "filtre-kahve-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/filtre-kahve-makineleri/10380 - Animo Excelso Filtre Kahve Makinesi, 1.8 L.jpg" },
      { title_tr: "Ice Slush İçecek Makineleri", title_en: "Ice Slush Machines", slug: "ice-slush-icecek-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/ice-slush-icecek-makineleri/SLUSH12.I Mono Ice Slush Granita Milkshake ve Soğuk Meyve Suyu Dispenseri, 12 L, Inox.jpg" },
      { title_tr: "Isıtıcılı Sosluklar", title_en: "Heated Sauce Dispensers", slug: "isiticili-sosluklar", imageUrl: "/profinoks/products/icecek-makineleri/isiticili-sosluklar/2'li Isıtıcılı Sosluk sc3.webp" },
      { title_tr: "Kahve Değirmenleri", title_en: "Coffee Grinders", slug: "kahve-degirmenleri", imageUrl: "/profinoks/products/icecek-makineleri/kahve-degirmenleri/M2D - MACAP Kahve Değirmeni ONDEMAND beyaz.jpg" },
      { title_tr: "Kumda Kahve Makineleri", title_en: "Sand Coffee Machines", slug: "kumda-kahve-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/kumda-kahve-makineleri/Altın Kumda Kahve Makinesi - kf2.jpg" },
      { title_tr: "Köpüklü Ayran Dispenserleri", title_en: "Foamy Ayran Dispensers", slug: "kopuklu-ayran-dispenserleri", imageUrl: "/profinoks/products/icecek-makineleri/kopuklu-ayran-dispenserleri/KAM22.DI Panaromik Dijital Köpüklü Ayran Dispenseri, 22 L, Inox.jpg" },
      { title_tr: "Soğuk İçecek Dispenserleri", title_en: "Cold Beverage Dispensers", slug: "soguk-icecek-dispenserleri", imageUrl: "/profinoks/products/icecek-makineleri/soguk-icecek-dispenserleri/20.MB Klasik Mono Soğuk İçecek Dispenseri, 20 L, Karıştırıcılı, Siyah.jpg" },
      { title_tr: "Su ve Süt Otomatları", title_en: "Water and Milk Dispensers", slug: "su-ve-sut-otomatlari", imageUrl: "/profinoks/products/icecek-makineleri/su-ve-sut-otomatlari/120 Bardak Sıcak Su Otomatı su-otomati-tek-lamba.jpg" },
      { title_tr: "Sıcak İçecek Dispenserleri", title_en: "Hot Beverage Dispensers", slug: "sicak-icecek-dispenserleri", imageUrl: "/profinoks/products/icecek-makineleri/sicak-icecek-dispenserleri/HOT GOLD SC06 Sıcak Çikolata ve Sahlep Makinesi, 6 L, Gold.jpg" },
      { title_tr: "Çay Kazanları", title_en: "Tea Boilers", slug: "cay-kazanlari", imageUrl: "/profinoks/products/icecek-makineleri/cay-kazanlari/15 Model Elektrikli Çay Ocağı 14 lt - k30.jpg" },
      { title_tr: "Çay Makineleri", title_en: "Tea Machines", slug: "cay-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/cay-makineleri/120 Bardak Deluxe Çay Makinesi.jpg" },
      { title_tr: "Çikolata Sosluğu", title_en: "Chocolate Sauce Machine", slug: "cikolata-soslugu", imageUrl: "/profinoks/products/icecek-makineleri/cikolata-soslugu/Çikolata Sosluğu 2,8 lt sc1.webp" },
      { title_tr: "Çorba Isıtıcılar", title_en: "Soup Warmers", slug: "corba-isiticilar", imageUrl: "/profinoks/products/icecek-makineleri/corba-isiticilar/Bakır Prestij Model Maksi Çorba Isıtıcı 13 lt cb15.jpg" },
      { title_tr: "İçecek Hazırlık Makineleri", title_en: "Beverage Preparation Machines", slug: "icecek-hazirlik-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/icecek-hazirlik-makineleri/Bar Blender Pro bb02.jpg" },
    ]
  },
  { 
    id: 6, 
    title_tr: "SELF SERVİS ÜNİTELERİ", 
    title_en: "SELF SERVICE UNITS",
    slug: "self-servis", 
    imageUrl: "/profinoks/products/self-servis-uniteleri.jpg", 
    href: "/products/self-servis", 
    description_tr: "Yemek dağıtım ve self servis hatları.",
    description_en: "Food distribution and self-service lines.",
    subCategories: [
      { title_tr: "Kuver Üniteleri", title_en: "Cutlery Units", slug: "kuver-uniteleri", imageUrl: "/profinoks/products/self-servis/kuver-uniteleri/kuver-uniteleri.jpg" },
      { title_tr: "Standart Benmariler", title_en: "Standard Bain-Maries", slug: "standart-benmariler", imageUrl: "/profinoks/products/self-servis/standart-benmariler/standart-benmariler.jpg" },
      { title_tr: "Soğuk Servis Üniteleri", title_en: "Cold Service Units", slug: "soguk-servis-uniteleri", imageUrl: "/profinoks/products/self-servis/soguk-servis-uniteleri/soguk-servis-uniteleri.jpg" },
      { title_tr: "Kule Tip Soğuk Dolaplar", title_en: "Tower Type Cold Cabinets", slug: "kule-tip-soguk-dolaplar", imageUrl: "/profinoks/products/self-servis/kule-tip-soguk-dolaplar/kule-tip-soguk-dolaplar.jpg" },
      { title_tr: "Nötr Servis Üniteleri", title_en: "Neutral Service Units", slug: "notr-servis-uniteleri", imageUrl: "/profinoks/products/self-servis/notr-servis-uniteleri/notr-servis-uniteleri.jpg" },
      { title_tr: "Köşe Servis Üniteleri", title_en: "Corner Service Units", slug: "kose-servis-uniteleri", imageUrl: "/profinoks/products/self-servis/kose-servis-uniteleri/kose-servis-uniteleri.jpg" },
      { title_tr: "Kasa Tezgahları", title_en: "Cashier Counters", slug: "kasa-tezgahlari", imageUrl: "/profinoks/products/self-servis/kasa-tezgahlari/kasa-tezgahlari.jpg" },
      { title_tr: "Eko Benmariler", title_en: "Eco Bain-Maries", slug: "eko-benmariler", imageUrl: "/profinoks/products/self-servis/eko-benmariler/eko-benmariler.jpg" },
      { title_tr: "Orta Tip Ahşap Kaplamalı Saladbarlar", title_en: "Central Wood Veneered Salad Bars", slug: "orta-tip-ahsap-kaplamali-saladbarlar", imageUrl: "/profinoks/products/self-servis/orta-tip-ahsap-kaplamali-saladbarlar/orta-tip-ahsap-kaplamali-saladbarlar.jpg" },
      { title_tr: "Orta Tip Ahşap Kaplamalı Benmariler", title_en: "Central Wood Veneered Bain-Maries", slug: "orta-tip-ahsap-kaplamali-benmariler", imageUrl: "/profinoks/products/self-servis/orta-tip-ahsap-kaplamali-benmariler/orta-tip-ahsap-kaplamali-benmariler.jpg" },
      { title_tr: "Montajlanmış Self Servis Hatları", title_en: "Assembled Self-Service Lines", slug: "montajlanmis-self-servis-hatlari", imageUrl: "/profinoks/products/self-servis/montajlanmis-self-servis-hatlari/montajlanmis-self-servis-hatlari.jpg" }
    ]
  },
  { 
    id: 7, 
    title_tr: "AÇIK BÜFE SERVİS ÜNİTELERİ", 
    title_en: "OPEN BUFFET SERVICE UNITS",
    slug: "acik-bufe", 
    imageUrl: "/profinoks/products/acik-bufe-servis-uniteleri.jpg", 
    href: "/products/acik-bufe", 
    description_tr: "Modern ve estetik açık büfe sunum çözümleri.",
    description_en: "Modern and aesthetic open buffet presentation solutions."
  },
  { 
    id: 8, 
    title_tr: "BUZDOLAPLAR VE DONDURUCULAR", 
    title_en: "REFRIGERATORS AND FREEZERS",
    slug: "buzdolaplar-ve-dondurucular", 
    imageUrl: "/profinoks/products/buzdolaplari.jpg", 
    href: "/products/buzdolaplar-ve-dondurucular", 
    description_tr: "Endüstriyel tip buzdolapları, dondurucular ve teşhir üniteleri.",
    description_en: "Industrial type refrigerators, freezers and display units.",
    subCategories: [
      { title_tr: "Buz Makineleri", title_en: "Ice Machines", slug: "buz-makineleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Buz Makineleri/Kastel KP 175-75 Buz Makinesi 175 Kg-gün Kapasiteli.jpg" },
      { title_tr: "Buzdolaplar ve Dondurucular", title_en: "Refrigerators and Freezers", slug: "refrigerators-and-freezers", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Buzdolaplar ve Dondurucular/DİKEY TİP BUZDOLAPLAR/PRF.208420012000 DİKEY TİP ÇİFT KAPILI BUZDOLABI +2, +8C°.png" },
      { title_tr: "Dondurma Makineleri", title_en: "Ice Cream Machines", slug: "dondurma-makineleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Dondurma Makineleri/Dikey Tip Dondurma Makineleri/Vbf-50-160 Dikey Dondurma Makinesi 50-160 Lt, 605x930x1330 mm..jpg" },
      { title_tr: "Dondurma Teşhir Vitrinleri", title_en: "Ice Cream Display Cabinets", slug: "dondurma-teshir-vitrinleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Dondurma Teşhir Vitrinleri/Aqua Serisi/Aqua-12 Dondurma Teşhir Vitrini 12 x 5 Lt, 1212x1129x1321 mm..png" },
      { title_tr: "Su Sebilleri", title_en: "Water Dispensers", slug: "su-sebilleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Su Sebilleri/P.SBL.80.01 Su Sebili (İç Dış Paslanmaz) 80 Lt, 600x500x1480 mm..jpg" },
      { title_tr: "Teşhir Dolapları", title_en: "Display Cabinets", slug: "teshir-dolaplari", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Teşhir Dolapları/P.BCPD.80.01.P Bombe Camlı Dik Tip Pasta Teşhir Dolabı Soğutmalı 800x700x1300 mm..jpg" },
    ]
  },
  { 
    id: 9, 
    title_tr: "SOĞUK ODALAR", 
    title_en: "COLD ROOMS",
    slug: "soguk-odalar", 
    imageUrl: "/profinoks/products/soguk-odalar.jpg", 
    href: "/products/soguk-odalar", 
    description_tr: "Panel tip soğuk oda ve depo çözümleri.",
    description_en: "Panel type cold room and storage solutions."
  },
  { 
    id: 10, 
    title_tr: "TEZGAHLAR", 
    title_en: "WORK BENCHES",
    slug: "tezgahlar", 
    imageUrl: "/profinoks/products/tezgahlar.jpg", 
    href: "/products/tezgahlar", 
    description_tr: "Çalışma, evyeli ve hazırlık tezgahları.",
    description_en: "Work benches, sink tables and preparation benches.",
    subCategories: [
          {
                "title_tr": "Bulaşık Makinası Giriş Tezgahı Taban Rafsız Tek Evyeli (400x500x250 Evyeli)",
                "title_en": "Dishwasher Inlet Table without Bottom Shelf Single Sink (400x500x250 Sink)",
                "slug": "bulasik-makinasi-giris-tezgahi-taban-rafsiz-tek-evyeli-400x500x250-evyeli",
                "imageUrl": "/profinoks/products/tezgahlar/bulasik-makinasi-giris-tezgahi-taban-rafsiz-tek-evyeli-400x500x250-evyeli/P.BMGE.75.01_Bulaşık_Makinası_Giriş_Tezgahı_Taban_Rafsız_Tek_Evyeli_400x500x250_Evyeli_800x750x850_mm.jpg"
          },
          {
                "title_tr": "Bulaşık Makinası Giriş Tezgahı Taban Rafsız İki Evyeli (400x500x250 Evyeli)",
                "title_en": "Dishwasher Inlet Table without Bottom Shelf Double Sink (400x500x250 Sink)",
                "slug": "bulasik-makinasi-giris-tezgahi-taban-rafsiz-iki-evyeli-400x500x250-evyeli",
                "imageUrl": "/profinoks/products/tezgahlar/bulasik-makinasi-giris-tezgahi-taban-rafsiz-iki-evyeli-400x500x250-evyeli/P.BMG2E.75.01_Bulaşık_Makinası_Giriş_Tezgahı_Taban_Rafsız_İki_Evyeli_400x500x250_Evyeli_1400x750x850.jpg"
          },
          {
                "title_tr": "Bulaşık Makinası Çıkış Tezgahı Taban Rafsız",
                "title_en": "Dishwasher Outlet Table without Bottom Shelf",
                "slug": "bulasik-makinasi-cikis-tezgahi-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/bulasik-makinasi-cikis-tezgahi-taban-rafsiz/P.BMÇ.75.01_Bulaşık_Makinası_Çıkış_Tezgahı_Taban_Rafsız_800x750x850_mm.jpg"
          },
          {
                "title_tr": "Bıçak Steril Dolabı (10 Bıçak)",
                "title_en": "Knife Sterilizer Cabinet (10 Knives)",
                "slug": "bicak-steril-dolabi-10-bicak",
                "imageUrl": "/profinoks/products/tezgahlar/bicak-steril-dolabi-10-bicak/P.BSD.40.01_Bıçak_Steril_Dolabı_10_Bıçak_520x120x630_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Modülü Çarpma Kapılı Ara Raflı",
                "title_en": "Cupboard Work Unit with Hinged Door and Intermediate Shelf",
                "slug": "dolapli-calisma-modulu-carpma-kapili-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-modulu-carpma-kapili-ara-rafli/P.DTTÇM.60.01_Dolaplı_Çalışma_Modülü_Çarpma_Kapılı_Ara_Raflı_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Ara Raflı Isıtıcı Modüllü",
                "title_en": "Cupboard Worktable with Intermediate Shelf and Heated Module",
                "slug": "dolapli-calisma-tezgahi-ara-rafli-isitici-modullu",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-ara-rafli-isitici-modullu/P.HÇTT.60.01_Dolaplı_Çalışma_Tezgahı_Ara_Raflı_Isıtıcı_Modüllü_1400x700x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Ara Raflı Önü Açık",
                "title_en": "Cupboard Worktable Open Front with Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-ara-rafli-onu-acik",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-ara-rafli-onu-acik/P.DTTA.60.01_Dolaplı_Çalışma_Tezgahı_Ara_Raflı_Önü_Açık_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Ara Rafsız Önü Açık",
                "title_en": "Cupboard Worktable Open Front without Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-ara-rafsiz-onu-acik",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-ara-rafsiz-onu-acik/P.DTA.60.01_Dolaplı_Çalışma_Tezgahı_Ara_Rafsız_Önü_Açık_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Sürgü Kapılı Ara Raflı",
                "title_en": "Cupboard Worktable with Sliding Doors and Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-surgu-kapili-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-surgu-kapili-ara-rafli/P.DÇSA.60.01_Dolaplı_Çalışma_Tezgahı_Sürgü_Kapılı_Ara_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Sürgü Kapılı Ara Rafsız",
                "title_en": "Cupboard Worktable with Sliding Doors without Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-surgu-kapili-ara-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-surgu-kapili-ara-rafsiz/P.DÇS.60.01_Dolaplı_Çalışma_Tezgahı_Sürgü_Kapılı_Ara_Rafsız_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Sürgü Kapılı Tek Evyeli",
                "title_en": "Cupboard Worktable with Upstand, Sliding Doors, Single Sink without Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili-tek-evyeli",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili-tek-evyeli/P.DÇSE.60.01_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Sürgü_Kapılı_400x400x250_Tek_Evyeli_1200x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Çarpma Kapılı Tek Evyeli",
                "title_en": "Cupboard Worktable with Upstand, Hinged Doors, Single Sink without Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili-tek-evyeli",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili-tek-evyeli/P.DÇÇE.60.01_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Çarpma_Kapılı_400x400x250_Tek_Evyeli_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Sırtlı Devrilir Ekmeklik Modülü",
                "title_en": "Cupboard Worktable with Upstand and Tilting Bread Bin Module",
                "slug": "dolapli-calisma-tezgahi-sirtli-devrilir-ekmeklik-modulu",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-sirtli-devrilir-ekmeklik-modulu/P.DÇTDE.60.01_Dolaplı_Çalışma_Tezgahı_Sırtlı_Devrilir_Ekmeklik_Modülü_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Çarpma Kapılı Ara Raflı",
                "title_en": "Cupboard Worktable with Hinged Doors and Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-carpma-kapili-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-carpma-kapili-ara-rafli/P.DTTÇ.60.01_Dolaplı_Çalışma_Tezgahı_Çarpma_Kapılı_Ara_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Dolaplı Çalışma Tezgahı Çarpma Kapılı Ara Rafsız",
                "title_en": "Cupboard Worktable with Hinged Doors without Intermediate Shelf",
                "slug": "dolapli-calisma-tezgahi-carpma-kapili-ara-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-carpma-kapili-ara-rafsiz/P.DTÇ.60.01_Dolaplı_Çalışma_Tezgahı_Çarpma_Kapılı_Ara_Rafsız_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Duvar Dolabı Sürgü Kapılı Ara Raflı",
                "title_en": "Wall Cupboard with Sliding Doors and Intermediate Shelf",
                "slug": "duvar-dolabi-surgu-kapili-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-surgu-kapili-ara-rafli/P.DDSA.40.01_Duvar_Dolabı_Sürgü_Kapılı_Ara_Raflı_900x400x600_mm.jpg"
          },
          {
                "title_tr": "Duvar Dolabı Sürgü Kapılı Ara Rafsız",
                "title_en": "Wall Cupboard with Sliding Doors without Intermediate Shelf",
                "slug": "duvar-dolabi-surgu-kapili-ara-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-surgu-kapili-ara-rafsiz/P.DDS.40.01_Duvar_Dolabı_Sürgü_Kapılı_Ara_Rafsız_900x400x600_mm.jpg"
          },
          {
                "title_tr": "Duvar Dolabı Çarpma Kapılı Ara Raflı",
                "title_en": "Wall Cupboard with Hinged Doors and Intermediate Shelf",
                "slug": "duvar-dolabi-carpma-kapili-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-carpma-kapili-ara-rafli/P.DDÇA.40.01_Duvar_Dolabı_Çarpma_Kapılı_Ara_Raflı_900x400x600_mm.jpg"
          },
          {
                "title_tr": "Duvar Dolabı Çarpma Kapılı Ara Rafsız",
                "title_en": "Wall Cupboard with Hinged Doors without Intermediate Shelf",
                "slug": "duvar-dolabi-carpma-kapili-ara-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-carpma-kapili-ara-rafsiz/P.DDÇ.40.01_Duvar_Dolabı_Çarpma_Kapılı_Ara_Rafsız_900x400x600_mm.jpg"
          },
          {
                "title_tr": "Duvar Dolabı Ön Açık Ara Raflı",
                "title_en": "Wall Cupboard Open Front with Intermediate Shelf",
                "slug": "duvar-dolabi-on-acik-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-on-acik-ara-rafli/P.DDA.40.01_Duvar_Dolabı_Ön_Açık_Ara_Raflı_900x400x600_mm.jpg"
          },
          {
                "title_tr": "Duvar Dolabı Ön Açık Ara Rafsız",
                "title_en": "Wall Cupboard Open Front without Intermediate Shelf",
                "slug": "duvar-dolabi-on-acik-ara-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-on-acik-ara-rafsiz/P.DD.40.01_Duvar_Dolabı_Ön_Açık_Ara_Rafsız_900x400x600_mm.jpg"
          },
          {
                "title_tr": "Duvar Rafı Tek Katlı",
                "title_en": "Single Tier Wall Shelf",
                "slug": "duvar-rafi-tek-katli",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-rafi-tek-katli/P.DVR1.30.01_Duvar_Rafı_Tek_Katlı_800x300x30_mm.jpg"
          },
          {
                "title_tr": "Duvar Rafı Çift Katlı",
                "title_en": "Double Tier Wall Shelf",
                "slug": "duvar-rafi-cift-katli",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-rafi-cift-katli/P.DVR2.30.01_Duvar_Rafı_Çift_Katlı_800x300x30_mm.jpg"
          },
          {
                "title_tr": "Duvar Rafı Üç Katlı",
                "title_en": "Triple Tier Wall Shelf",
                "slug": "duvar-rafi-uc-katli",
                "imageUrl": "/profinoks/products/tezgahlar/duvar-rafi-uc-katli/P.DVR3.30.01_Duvar_Rafı_Üç_Katlı_800x300x30_mm.jpg"
          },
          {
                "title_tr": "Ekmek Dolabı",
                "title_en": "Bread Cabinet",
                "slug": "ekmek-dolabi",
                "imageUrl": "/profinoks/products/tezgahlar/ekmek-dolabi/P.EKD.40.04_Ekmek_Dolabı_1000x500x1600_mm.jpg"
          },
          {
                "title_tr": "Galoş Bone Dolabı",
                "title_en": "Shoe Cover & Hairnet Cabinet",
                "slug": "galos-bone-dolabi",
                "imageUrl": "/profinoks/products/tezgahlar/galos-bone-dolabi/P.GBD.01_Galoş_Bone_Dolabı_500x250x400_mm.jpg"
          },
          {
                "title_tr": "Galoş Bone Dolabı, Çöp Hazneli",
                "title_en": "Shoe Cover & Hairnet Cabinet with Waste Bin",
                "slug": "galos-bone-dolabi-cop-hazneli",
                "imageUrl": "/profinoks/products/tezgahlar/galos-bone-dolabi-cop-hazneli/P.GBDÇ.01_Galoş_Bone_Dolabı_Çöp_Hazneli_500x250x800_mm.jpg"
          },
          {
                "title_tr": "Garnitürlük",
                "title_en": "Garnish Dispenser",
                "slug": "garniturluk",
                "imageUrl": "/profinoks/products/tezgahlar/garniturluk/P.GRN.30.01_Garnitürlük_GN1-4x100mm_küvetli_900x300x200_mm.jpg"
          },
          {
                "title_tr": "Hareketli Çalışma Tezgahı Ara Raflı",
                "title_en": "Mobile Worktable with Intermediate Shelf",
                "slug": "hareketli-calisma-tezgahi-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/hareketli-calisma-tezgahi-ara-rafli/P.HÇTTA.60.01_Hareketli_Çalışma_Tezgahı_Ara_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Hareketli Çalışma Tezgahı Taban Raflı",
                "title_en": "Mobile Worktable with Bottom Shelf",
                "slug": "hareketli-calisma-tezgahi-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/hareketli-calisma-tezgahi-taban-rafli/P.HÇTT.60.01_Hareketli_Çalışma_Tezgahı_Taban_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Kazan Kabul Tezgahı",
                "title_en": "Pot Reception Table",
                "slug": "kazan-kabul-tezgahi",
                "imageUrl": "/profinoks/products/tezgahlar/kazan-kabul-tezgahi/P.KKT.60.01_Kazan_Kabul_Tezgahı_1000x800x550360_mm.jpg"
          },
          {
                "title_tr": "Kazan Yıkama Tezgahı",
                "title_en": "Pot Washing Table",
                "slug": "kazan-yikama-tezgahi",
                "imageUrl": "/profinoks/products/tezgahlar/kazan-yikama-tezgahi/P.KYT.60.01_Kazan_Yıkama_Tezgahı_1000x800x550360_mm.jpg"
          },
          {
                "title_tr": "Kepçe Askı Borusu",
                "title_en": "Ladle Hanging Rail",
                "slug": "kepce-aski-borusu",
                "imageUrl": "/profinoks/products/tezgahlar/kepce-aski-borusu/P.KAB1.30.01_Kepçe_Askı_Borusu_900x60x20_mm.jpg"
          },
          {
                "title_tr": "Mermer Tablalı Çalışma Tezgahı Taban Raflı",
                "title_en": "Worktable with Marble Top & Bottom Shelf",
                "slug": "mermer-tablali-calisma-tezgahi-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/mermer-tablali-calisma-tezgahi-taban-rafli/P.MTÇTT.70.01_Mermer_Tablalı_Çalışma_Tezgahı_Taban_Raflı_900x700x850_mm.jpg"
          },
          {
                "title_tr": "Mermer Tablalı Çalışma Tezgahı Taban Rafsız",
                "title_en": "Worktable with Marble Top without Bottom Shelf",
                "slug": "mermer-tablali-calisma-tezgahi-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/mermer-tablali-calisma-tezgahi-taban-rafsiz/P.MTÇT.70.01_Mermer_Tablalı_Çalışma_Tezgahı_Taban_Rafsız_900x700x850_mm.jpg"
          },
          {
                "title_tr": "Paspas Yıkama Evyesi",
                "title_en": "Mop Sink",
                "slug": "paspas-yikama-evyesi",
                "imageUrl": "/profinoks/products/tezgahlar/paspas-yikama-evyesi/P.PYE.01_Paspas_Yıkama_Evyesi_600x700x850_mm.jpg"
          },
          {
                "title_tr": "Polietilen Tablalı Çalışma Tezgahı Taban Raflı",
                "title_en": "Worktable with Polyethylene Top & Bottom Shelf",
                "slug": "polietilen-tablali-calisma-tezgahi-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/polietilen-tablali-calisma-tezgahi-taban-rafli/P.PTÇTT.60.01_Polietilen_Tablalı_Çalışma_Tezgahı_Taban_Raflı_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Polietilen Tablalı Çalışma Tezgahı Taban Rafsız",
                "title_en": "Worktable with Polyethylene Top without Bottom Shelf",
                "slug": "polietilen-tablali-calisma-tezgahi-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/polietilen-tablali-calisma-tezgahi-taban-rafsiz/P.PTÇT.60.01_Polietilen_Tablalı_Çalışma_Tezgahı_Taban_Rafsız_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Polietilen Çalışma Tezgahı Et Kütüğü",
                "title_en": "Polyethylene Worktable Chopping Block",
                "slug": "polietilen-calisma-tezgahi-et-kutugu",
                "imageUrl": "/profinoks/products/tezgahlar/polietilen-calisma-tezgahi-et-kutugu/P.PTÇTE.60.01_Polietilen_Çalışma_Tezgahı_Et_Kütüğü_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Sebze Süzme Tezgahı",
                "title_en": "Vegetable Draining Table",
                "slug": "sebze-suzme-tezgahi",
                "imageUrl": "/profinoks/products/tezgahlar/sebze-suzme-tezgahi/P.SST.60.01_Sebze_Süzme_Tezgahı_1000x600x850_mm.jpg"
          },
          {
                "title_tr": "Tek Evyeli Çalışma Tezgahı Sırtlı Taban Raflı",
                "title_en": "Single Sink Worktable with Upstand & Bottom Shelf",
                "slug": "tek-evyeli-calisma-tezgahi-sirtli-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/tek-evyeli-calisma-tezgahi-sirtli-taban-rafli/P.TTE.60.01_Tek_Evyeli_400x400x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Tek Evyeli Çalışma Tezgahı Sırtlı Taban Rafsız",
                "title_en": "Single Sink Worktable with Upstand without Bottom Shelf",
                "slug": "tek-evyeli-calisma-tezgahi-sirtli-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/tek-evyeli-calisma-tezgahi-sirtli-taban-rafsiz/P.TE.60.01_Tek_Evyeli_400x400x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Temizlik Ekipman Dolabı",
                "title_en": "Cleaning Equipment Cabinet",
                "slug": "temizlik-ekipman-dolabi",
                "imageUrl": "/profinoks/products/tezgahlar/temizlik-ekipman-dolabi/P.TED.40.01_Temizlik_Ekipman_Dolabı_1000x400x1600_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Ara ve Taban Raflı",
                "title_en": "Worktable with Intermediate and Bottom Shelf",
                "slug": "calisma-tezgahi-ara-ve-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-ara-ve-taban-rafli/P.ÇTTA.60.01_Çalışma_Tezgahı_Ara_ve_Taban_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Blok Çekmece Modülü",
                "title_en": "Worktable Drawer Block Module",
                "slug": "calisma-tezgahi-blok-cekmece-modulu",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmece-modulu/P.BÇEK.60.01_Çalışma_Tezgahı_Üçlü_Blok_Çekmece_Modülü_600x600x700_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Blok Çekmeceli Taban Raflı",
                "title_en": "Worktable with Drawer Block & Bottom Shelf",
                "slug": "calisma-tezgahi-blok-cekmeceli-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-taban-rafli/P.ÇTBÇ.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Taban_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Blok Çekmeceli Taban Rafsız",
                "title_en": "Worktable with Drawer Block without Bottom Shelf",
                "slug": "calisma-tezgahi-blok-cekmeceli-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-taban-rafsiz/P.ÇBÇ.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Taban_Rafsız_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Blok Çekmeceli Taban ve Ara Raflı",
                "title_en": "Worktable with Drawer Block, Bottom and Intermediate Shelf",
                "slug": "calisma-tezgahi-blok-cekmeceli-taban-ve-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-taban-ve-ara-rafli/P.ÇTTBÇ.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Taban_ve_Ara_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Blok Çekmeceli Çarpma Kapılı Taban Raflı",
                "title_en": "Worktable with Drawer Block, Hinged Door & Bottom Shelf",
                "slug": "calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-rafli/P.ÇÇTB.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Çarpma_Kapılı_Taban_Raflı_1100x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Blok Çekmeceli Çarpma Kapılı Taban ve Ara Raflı",
                "title_en": "Worktable with Drawer Block, Hinged Door, Bottom and Intermediate Shelf",
                "slug": "calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-ve-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-ve-ara-rafli/P.ÇÇAB.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Çarpma_Kapılı_Taban_Raflı_1100x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Köşe Ünitesi Sırtlı Taban Raflı",
                "title_en": "Corner Worktable Unit with Upstand and Bottom Shelf",
                "slug": "calisma-tezgahi-kose-unitesi-sirtli-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-kose-unitesi-sirtli-taban-rafli/P.ÇTKT.60.01_Çalışma_Tezgahı_Köşe_Ünitesi_Sırtlı_Taban_Raflı_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Köşe Ünitesi Sırtlı Taban Rafsız",
                "title_en": "Corner Worktable Unit with Upstand without Bottom Shelf",
                "slug": "calisma-tezgahi-kose-unitesi-sirtli-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-kose-unitesi-sirtli-taban-rafsiz/P.ÇTK.60.01_Çalışma_Tezgahı_Köşe_Ünitesi_Sırtlı_Taban_Rafsız_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Köşe Ünitesi Sırtlı Taban ve Ara Raflı",
                "title_en": "Corner Worktable Unit with Upstand, Bottom and Intermediate Shelf",
                "slug": "calisma-tezgahi-kose-unitesi-sirtli-taban-ve-ara-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-kose-unitesi-sirtli-taban-ve-ara-rafli/P.ÇTKTA.60.01_Çalışma_Tezgahı_Köşe_Ünitesi_Sırtlı_Taban_ve_Ara_Raflı_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Sırtlı Dörtlü Blok Çekmeceli Ünite",
                "title_en": "Worktable with Upstand & 4-Drawer Block Unit",
                "slug": "calisma-tezgahi-sirtli-dortlu-blok-cekmeceli-unite",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-dortlu-blok-cekmeceli-unite/P.ÇT4BU.60.01_Çalışma_Tezgahı_Sırtlı_Dörtlü_Blok_Çekmeceli_Ünite_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Sırtlı Taban Raflı",
                "title_en": "Worktable with Upstand & Bottom Shelf",
                "slug": "calisma-tezgahi-sirtli-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-taban-rafli/P.ÇTT.60.01_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Sırtlı Taban Rafsız",
                "title_en": "Worktable with Upstand without Bottom Shelf",
                "slug": "calisma-tezgahi-sirtli-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-taban-rafsiz/P.ÇT.60.01_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_900x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Sırtlı Üçlü Blok Çekmeceli Ünite",
                "title_en": "Worktable with Upstand & 3-Drawer Block Unit",
                "slug": "calisma-tezgahi-sirtli-uclu-blok-cekmeceli-unite",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-uclu-blok-cekmeceli-unite/P.ÇT3BU.60.01_Çalışma_Tezgahı_Sırtlı_Üçlü_Blok_Çekmeceli_Ünite_600x600x850_mm.jpg"
          },
          {
                "title_tr": "Çalışma Tezgahı Çekmece Modülü",
                "title_en": "Worktable Drawer Module",
                "slug": "calisma-tezgahi-cekmece-modulu",
                "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-cekmece-modulu/P.TÇEK.60.01_Çalışma_Tezgahı_Çekmece_Modülü_140-600_Seri_534x558x141_mm.jpg"
          },
          {
                "title_tr": "Çöp Sıyırma Tezgahı",
                "title_en": "Waste Scraping Table",
                "slug": "cop-siyirma-tezgahi",
                "imageUrl": "/profinoks/products/tezgahlar/cop-siyirma-tezgahi/P.ÇST.70.01_Çöp_Sıyırma_Tezgahı_1100x700x850_mm.jpg"
          },
          {
                "title_tr": "Üç Evyeli Çalışma Tezgahı Sırtlı Taban Raflı",
                "title_en": "Triple Sink Worktable with Upstand & Bottom Shelf",
                "slug": "uc-evyeli-calisma-tezgahi-sirtli-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/uc-evyeli-calisma-tezgahi-sirtli-taban-rafli/P.TT3E.60.01_Üç_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_1900x600x850_mm.jpg"
          },
          {
                "title_tr": "Üç Evyeli Çalışma Tezgahı Sırtlı Taban Rafsız",
                "title_en": "Triple Sink Worktable with Upstand without Bottom Shelf",
                "slug": "uc-evyeli-calisma-tezgahi-sirtli-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/uc-evyeli-calisma-tezgahi-sirtli-taban-rafsiz/P.T3E.60.01_Üç_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_1900x600x850_mm.jpg"
          },
          {
                "title_tr": "İki Evyeli Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Sürgü Kapılı",
                "title_en": "Double Sink Cupboard Worktable with Upstand, Sliding Doors without Intermediate Shelf",
                "slug": "iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili",
                "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili/P.DÇS2E.60.01_İki_Evyeli_400x400x250_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Sürgü_Kapılı_1200x600x850_mm.jpg"
          },
          {
                "title_tr": "İki Evyeli Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Çarpma Kapılı",
                "title_en": "Double Sink Cupboard Worktable with Upstand, Hinged Doors without Intermediate Shelf",
                "slug": "iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili",
                "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili/P.DÇÇ2E.60.01_İki_Evyeli_400x400x250_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Çarpma_Kapılı_1200x600x850_mm.jpg"
          },
          {
                "title_tr": "İki Evyeli Çalışma Tezgahı Sırtlı Taban Raflı",
                "title_en": "Double Sink Worktable with Upstand & Bottom Shelf",
                "slug": "iki-evyeli-calisma-tezgahi-sirtli-taban-rafli",
                "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-calisma-tezgahi-sirtli-taban-rafli/P.TT2E.60.01_İki_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_1200x600x850_mm.jpg"
          },
          {
                "title_tr": "İki Evyeli Çalışma Tezgahı Sırtlı Taban Rafsız",
                "title_en": "Double Sink Worktable with Upstand without Bottom Shelf",
                "slug": "iki-evyeli-calisma-tezgahi-sirtli-taban-rafsiz",
                "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-calisma-tezgahi-sirtli-taban-rafsiz/P.T2E.60.01_İki_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_1200x600x850_mm.jpg"
          }
    ]
  },
  { 
    id: 11, 
    title_tr: "İSTİF RAFLARI VE DEPOLAMA", 
    title_en: "STORAGE RACKS",
    slug: "istif-raflari", 
    imageUrl: "/profinoks/products/istif-raflari.jpg", 
    href: "/products/istif-raflari", 
    description_tr: "Mutfak ve depo için raf sistemleri.",
    description_en: "Rack systems for kitchen and warehouse.",
    subCategories: [
      { title_tr: "Düz Raflar", title_en: "Flat Shelves", slug: "duz-raflar", imageUrl: "/profinoks/products/istif-raflari/duz-raflar/3 Katlı Paslanmaz Düz Raf - INOX 304.jpg" },
      { title_tr: "Perfore Raflar", title_en: "Perforated Shelves", slug: "perfore-raflar", imageUrl: "/profinoks/products/istif-raflari/perfore-raflar/3 Katlı Paslanmaz Perfore Raf - INOX 304.jpg" },
      { title_tr: "Plastik Raflar", title_en: "Plastic Shelves", slug: "plastik-raflar", imageUrl: "/profinoks/products/istif-raflari/plastik-raflar/3 Katlı Plastik Paslanmaz Raf - 304 Kalite Şase.jpg" },
      { title_tr: "Raf Ekipmanları", title_en: "Shelf Equipment", slug: "raf-ekipmanlari", imageUrl: "/profinoks/products/istif-raflari/raf-ekipmanlari/Paslanmaz Düz Raf Tablası - INOX 304.jpg" },
      { title_tr: "Tel Raflar", title_en: "Wire Shelves", slug: "tel-raflar", imageUrl: "/profinoks/products/istif-raflari/tel-raflar/3 Katlı Paslanmaz Krom Tel Raf - INOX 304.jpg" },
      { title_tr: "Üstü Delikli Plastik Paletler", title_en: "Perforated Plastic Pallets", slug: "ustu-delikli-plastik-paletler", imageUrl: "/profinoks/products/istif-raflari/ustu-delikli-plastik-paletler/100x120 cm Üstü Delikli Palet - 1012-KSMA.jpg" },
      { title_tr: "Üstü Kapalı Plastik Paletler", title_en: "Closed Top Plastic Pallets", slug: "ustu-kapali-plastik-paletler", imageUrl: "/profinoks/products/istif-raflari/ustu-kapali-plastik-paletler/100x120 cm Plastik Ağır Yük Paleti - 1012-PVP.jpg" },
    ]
  },
  { 
    id: 12, 
    title_tr: "YER IZGARALARI & YAĞ AYIRICILAR", 
    title_en: "FLOOR DRAINS & GREASE TRAPS",
    slug: "yer-izgaralari", 
    imageUrl: "/profinoks/products/yer-izgaralari.jpg", 
    href: "/products/yer-izgaralari", 
    description_tr: "Drenaj kanalları ve yağ ayırıcı sistemler.",
    description_en: "Drainage channels and grease trap systems.",
    subCategories: [
      { title_tr: "Hijyen Paspası ve Tavası", title_en: "Hygiene Mat and Tray", slug: "hijyen-paspasi-ve-tavasi", imageUrl: "/profinoks/products/yer-izgaralari/Hijyen Paspası ve Tavası/P.HPAS.01 Hijyen Paspası ve Tavası 800x600x20 mm.jpg" },
      { title_tr: "Yağ Ayırıcılar ( Yağ Tutucular )", title_en: "Grease Traps", slug: "yag-ayiricilar", imageUrl: "/profinoks/products/yer-izgaralari/Yağ Ayırıcılar ( Yağ Tutucular )/P.YAG.01 Yağ Ayırıcı ( Yağ Tutucu ) 0,25 lt-sn 450x400x450 mm.jpg" },
      { title_tr: "Yer Izgaraları ( Yer Giderleri )", title_en: "Floor Drains", slug: "yer-izgaralari-giderleri", imageUrl: "/profinoks/products/yer-izgaralari/Yer Izgaraları ( Yer Giderleri )/Alttan Çıkışlı Kenardan Sifonlu Yer Izgaraları ( Yer Giderleri )/B-01 Alttan Çıkışlı Kenardan Sifonlu Yer Izgarası 300x300 mm.jpg" }
    ]
  },
  { 
    id: 13, 
    title_tr: "DAVLUMBAZLAR", 
    title_en: "EXTRACTOR HOODS",
    slug: "davlumbazlar", 
    imageUrl: "/profinoks/products/davlumbazlar.jpg", 
    href: "/products/davlumbazlar", 
    description_tr: "Havalandırma ve davlumbaz sistemleri.",
    description_en: "Ventilation and hood systems."
  },
  { 
    id: 14, 
    title_tr: "MUTFAK ARABALARI", 
    title_en: "KITCHEN TROLLEYS",
    slug: "mutfak-arabalari", 
    imageUrl: "/profinoks/products/mutfak-arabalari.jpg", 
    href: "/products/mutfak-arabalari", 
    description_tr: "Taşıma, servis ve toplama arabaları.",
    description_en: "Transport, service and clearing trolleys."
  },
  { 
    id: 15, 
    title_tr: "YARDIMCI MUTFAK EKİPMANLARI", 
    title_en: "AUXILIARY KITCHEN EQUIPMENT",
    slug: "yardimci-mutfak-ekipmanlari", 
    imageUrl: "/profinoks/products/yardimci-mutfak-ekipmanlari.jpg", 
    href: "/products/yardimci-mutfak-ekipmanlari", 
    description_tr: "Tencere, tava ve küçük el aletleri.",
    description_en: "Pots, pans and small hand tools."
  ,
    subCategories: [
        {
            "title_tr": "El Aletleri",
            "title_en": "El Aletleri",
            "slug": "el-aletleri",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/el-aletleri/5 Bıçaklı Yeşillik Makası - 83010003.jpg"
        },
        {
            "title_tr": "Gastronorm Küvet Kapakları",
            "title_en": "Gastronorm Container Lids",
            "slug": "gastronorm-kuvet-kapaklari",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/gastronorm-kuvet-kapaklari/GN 1÷1 Polikarbon Gastronorm Küvet Kapağı 325x530 mm.jpg"
        },
        {
            "title_tr": "Gastronorm Küvetler",
            "title_en": "Gastronorm Containers",
            "slug": "gastronorm-kuvetler",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/gastronorm-kuvetler/GN 1÷1-100mm Delikli Gastronorm Küvet 325x530x100 mm.jpg"
        },
        {
            "title_tr": "Kepçe, Kevgir, Spatula ve Kaşıklar",
            "title_en": "Ladles, Skimmers, Spatulas & Spoons",
            "slug": "kepce-kevgir-spatula-ve-kasiklar",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/kepce-kevgir-spatula-ve-kasiklar/Belli Pasta Spatula 25 cm - 62010025.jpg"
        },
        {
            "title_tr": "Ketçap, Mayonez ve Sosluklar",
            "title_en": "Ketchup, Mayonnaise & Sauce Dispensers",
            "slug": "ketcap-mayonez-ve-sosluklar",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/ketcap-mayonez-ve-sosluklar/Hardal Dispenseri - 46010025.jpg"
        },
        {
            "title_tr": "Maşalar",
            "title_en": "Tongs",
            "slug": "masalar",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/masalar/Buz Maşa 16 cm - 36303000.jpg"
        },
        {
            "title_tr": "Polietilen Ürünler",
            "title_en": "Polyethylene Products",
            "slug": "polietilen-urunler",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/polietilen-urunler/Bal Tokmağı Polietilen - 49020010.jpg"
        },
        {
            "title_tr": "Süzgeçler",
            "title_en": "Strainers & Colanders",
            "slug": "suzgecler",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/suzgecler/Exoglass Konik Sık Süzgeç 20x22 cm - 77507360.jpg"
        },
        {
            "title_tr": "Tel Kevgir ve Tel Süzgeçler",
            "title_en": "Wire Skimmers & Wire Strainers",
            "slug": "tel-kevgir-ve-tel-suzgecler",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/tel-kevgir-ve-tel-suzgecler/Kalbur Paslanmaz 25 cm - 44013125.jpg"
        },
        {
            "title_tr": "Tencere & Tavalar",
            "title_en": "Tencere & Tavalar",
            "slug": "tencere-tavalar",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/tencere-tavalar/2101500 Derin Silindirik Tencere, 3,2 lt 16x16 cm.jpg"
        },
        {
            "title_tr": "Termometreler",
            "title_en": "Termometreler",
            "slug": "termometreler",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/termometreler/Buzdolabı Termometresi - 62060007.jpg"
        },
        {
            "title_tr": "Yardımcı Makineler",
            "title_en": "Auxiliary Machines",
            "slug": "yardimci-makineler",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/yardimci-makineler/Hamburger Şekillendirici, Haznesi 10 cm - 41040010.jpg"
        },
        {
            "title_tr": "Çırpıcılar",
            "title_en": "Whisks",
            "slug": "cirpicilar",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/cirpicilar/Askılı Çırpıcı Paslanmaz 25 cm - 40010061.jpg"
        },
        {
            "title_tr": "Ölçülü Kaplar",
            "title_en": "Measuring Cups & Jugs",
            "slug": "olculu-kaplar",
            "imageUrl": "/profinoks/products/yardimci-mutfak-ekipmanlari/olculu-kaplar/Dörtlü Ölçü Kaşık Seti 2,5 cc - 5 cc - 7,5 cc -15 cc - 40010059.jpg"
        }
    ]},
  { 
    id: 16, 
    title_tr: "Horeca Setüstü", 
    title_en: "Horeca Setüstü",
    slug: "horeca-setustu", 
    imageUrl: "/profinoks/products/horeca-setustu.jpg", 
    href: "/products/horeca-setustu", 
    description_tr: "Otel odası ve restoran setüstü ekipmanları.",
    description_en: "Hotel room and restaurant tabletop equipment.",
      subCategories: [
          {
              "title_tr": "Porselen Grubu",
              "title_en": "Porcelain Group",
              "slug": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu.jpg"
          },
          {
              "title_tr": "Bonna Porselen",
              "title_en": "Bonna Porcelain",
              "slug": "bonna-porselen",
              "parent": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/bonna.jpg"
          },
          {
              "title_tr": "By Bone Porselen",
              "title_en": "By Bone Porcelain",
              "slug": "by-bone-porselen",
              "parent": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/by-bone.jpg"
          },
          {
              "title_tr": "Güral Porselen",
              "title_en": "Güral Porcelain",
              "slug": "gural-porselen",
              "parent": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/gural.jpg"
          },
          {
              "title_tr": "ID Fine Porselen",
              "title_en": "ID Fine Porcelain",
              "slug": "id-fine-porselen",
              "parent": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/id-fine.jpg"
          },
          {
              "title_tr": "Jumbo Porselen",
              "title_en": "Jumbo Porcelain",
              "slug": "jumbo-porselen",
              "parent": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/jumbo-porselen.jpg"
          },
          {
              "title_tr": "Kütahya Porselen",
              "title_en": "Kütahya Porcelain",
              "slug": "kutahya-porselen",
              "parent": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/kutahya-porselen.jpg"
          },
          {
              "title_tr": "Porland Porselen",
              "title_en": "Porland Porcelain",
              "slug": "porland-porselen",
              "parent": "porselen-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/porland-porselen.jpg"
          },
          {
              "title_tr": "Çatal, Bıçak & Kaşık Grubu",
              "title_en": "Cutlery & Flatware Group",
              "slug": "catal-bicak-kasik-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu.jpg"
          },
          {
              "title_tr": "Hisar Çatal, Bıçak & Kaşık",
              "title_en": "Hisar Cutlery",
              "slug": "catal-bicak-kasik-grubu-hisar-catal-bicak-kasik",
              "parent": "catal-bicak-kasik-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/hisar.jpg"
          },
          {
              "title_tr": "Kılıçlar Çatal, Bıçak & Kaşık",
              "title_en": "Kılıçlar Cutlery",
              "slug": "catal-bicak-kasik-grubu-kiliclar-catal-bicak-kasik",
              "parent": "catal-bicak-kasik-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/kiliclar.jpg"
          },
          {
              "title_tr": "Jumbo Çatal, Bıçak & Kaşık",
              "title_en": "Jumbo Cutlery",
              "slug": "catal-bicak-kasik-grubu-jumbo-catal-bicak-kasik",
              "parent": "catal-bicak-kasik-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/jumbo.jpg"
          },
          {
              "title_tr": "Narin Çatal, Bıçak & Kaşık",
              "title_en": "Narin Cutlery",
              "slug": "catal-bicak-kasik-grubu-narin-catal-bicak-kasik",
              "parent": "catal-bicak-kasik-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/narin.jpg"
          },
          {
              "title_tr": "Cam Grubu",
              "title_en": "Glass Group",
              "slug": "cam-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu.jpg"
          },
          {
              "title_tr": "PAŞABAHÇE",
              "title_en": "PAŞABAHÇE",
              "slug": "cam-grubu-pasabahce",
              "parent": "cam-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu/pasabahce.jpg"
          },
          {
              "title_tr": "Nude",
              "title_en": "Nude",
              "slug": "cam-grubu-nude",
              "parent": "cam-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu/nude-koleksiyonu.jpg"
          },
          {
              "title_tr": "Lav",
              "title_en": "Lav",
              "slug": "cam-grubu-lav",
              "parent": "cam-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu/Lav.jpg"
          },
          {
              "title_tr": "Pişirme Ekipmanları",
              "title_en": "Cooking Equipment",
              "slug": "pisirme-ekipmanlari",
              "imageUrl": "/profinoks/products/horeca-setustu/pisirme-ekipmanlari.jpg"
          },
          {
              "title_tr": "Altınbaşak",
              "title_en": "Altınbaşak",
              "slug": "altinbasak",
              "parent": "pisirme-ekipmanlari",
              "imageUrl": "/profinoks/products/horeca-setustu/pisirme-ekipmanlari/altinbasak.jpg"
          },
          {
              "title_tr": "Novac",
              "title_en": "Novac",
              "slug": "novac",
              "parent": "pisirme-ekipmanlari",
              "imageUrl": "/profinoks/products/horeca-setustu/pisirme-ekipmanlari/novac.jpg"
          },
          {
              "title_tr": "Akrilik Grubu",
              "title_en": "Acrylic Group",
              "slug": "akrilik-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/akrilik-grubu.jpg"
          },
          {
              "title_tr": "Açık Büfe Ekipmanları",
              "title_en": "Open Buffet Equipment",
              "slug": "acik-bufe-ekipmanlari",
              "imageUrl": "/profinoks/products/horeca-setustu/acik-bufe-ekipmanlari.jpg"
          },
          {
              "title_tr": "Bakır Grubu",
              "title_en": "Copper Group",
              "slug": "bakir-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/bakir-grubu.jpg"
          },
          {
              "title_tr": "Bıçaklar",
              "title_en": "Knives",
              "slug": "bicaklar",
              "imageUrl": "/profinoks/products/horeca-setustu/bicaklar.jpg"
          },
          {
              "title_tr": "Pirge",
              "title_en": "Pirge",
              "slug": "pirge",
              "parent": "bicaklar",
              "imageUrl": "/profinoks/products/horeca-setustu/bicaklar/pirge.jpg"
          },
          {
              "title_tr": "Sürbisa",
              "title_en": "Sürbisa",
              "slug": "surbisa",
              "parent": "bicaklar",
              "imageUrl": "/profinoks/products/horeca-setustu/bicaklar/surbisa.jpg"
          },
          {
              "title_tr": "Masaüstü Ekipmanları",
              "title_en": "Tabletop Equipment",
              "slug": "masaustu-ekipmanlari",
              "imageUrl": "/profinoks/products/horeca-setustu/masaustu-ekipmanlari.jpg"
          },
          {
              "title_tr": "Ahşap Grubu",
              "title_en": "Wooden Group",
              "slug": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu.jpg"
          },
          {
              "title_tr": "Ayaklı Sunumlar",
              "title_en": "Pedestal Display Stands",
              "slug": "ahsap-ayakli-sunumlar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/ayakli-sunumlar.jpg"
          },
          {
              "title_tr": "Aşk Serisi",
              "title_en": "Love Series",
              "slug": "ahsap-ask-serisi",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/ask-serisi.jpg"
          },
          {
              "title_tr": "Baharatlıklar",
              "title_en": "Spice Dispensers & Shakers",
              "slug": "ahsap-baharatliklar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/baharatliklar.jpg"
          },
          {
              "title_tr": "Bakır Tavalar",
              "title_en": "Copper Pans",
              "slug": "ahsap-bakir-tavalar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/bakir-tavalar.jpg"
          },
          {
              "title_tr": "Bambu Bıçak ve Bileyiciler",
              "title_en": "Bamboo Knives & Sharpeners",
              "slug": "ahsap-bambu-bicak-ve-bileyiciler",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/bambu-bicak-ve-bileyiciler.jpg"
          },
          {
              "title_tr": "Bambu Çelik Ürünler",
              "title_en": "Bamboo Steel Products",
              "slug": "ahsap-bambu-celik-urunler",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/bambu-celik-urunler.jpg"
          },
          {
              "title_tr": "Bölmeli Tabaklar",
              "title_en": "Compartment Plates",
              "slug": "ahsap-bolmeli-tabaklar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/bolmeli-tabaklar.jpg"
          },
          {
              "title_tr": "Bıçaklar",
              "title_en": "Knives",
              "slug": "ahsap-bicaklar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/bicaklar.jpg"
          },
          {
              "title_tr": "Demir Döküm Sunumlar",
              "title_en": "Cast Iron Presentation Ware",
              "slug": "ahsap-demir-dokum-sunumlar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/demir-dokum-sunumlar.jpg"
          },
          {
              "title_tr": "Diğer Ürünler",
              "title_en": "Other Products",
              "slug": "ahsap-diger-urunler",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/diger-urunler.jpg"
          },
          {
              "title_tr": "Dönen Tabaklar",
              "title_en": "Rotating Serving Plates",
              "slug": "ahsap-donen-tabaklar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/donen-tabaklar.jpg"
          },
          {
              "title_tr": "Düzenleyiciler",
              "title_en": "Organizers",
              "slug": "ahsap-duzenleyiciler",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/duzenleyiciler.jpg"
          },
          {
              "title_tr": "French Press",
              "title_en": "French Press",
              "slug": "ahsap-french-press",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/french-press.jpg"
          },
          {
              "title_tr": "Kahvaltılık ve Çerezlikler",
              "title_en": "Breakfast & Snack Bowls",
              "slug": "ahsap-kahvaltilik-ve-cerezlikler",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/kahvaltilik-ve-cerezlikler.jpg"
          },
          {
              "title_tr": "Kaseler ve Tabaklar",
              "title_en": "Bowls and Plates",
              "slug": "ahsap-kaseler-ve-tabaklar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/kaseler-ve-tabaklar.jpg"
          },
          {
              "title_tr": "Kesme ve Steak Tahtaları",
              "title_en": "Cutting & Steak Boards",
              "slug": "ahsap-kesme-ve-steak-tahtalari",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/kesme-ve-steak-tahtalari.jpg"
          },
          {
              "title_tr": "Meşe Fıçılar",
              "title_en": "Oak Barrels",
              "slug": "ahsap-mese-ficilar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/mese-ficilar.jpg"
          },
          {
              "title_tr": "Peynir Setleri",
              "title_en": "Peynir Setleri",
              "slug": "ahsap-peynir-setleri",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/peynir-setleri.jpg"
          },
          {
              "title_tr": "Saklama Kapları",
              "title_en": "Storage Containers",
              "slug": "ahsap-saklama-kaplari",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/saklama-kaplari.jpg"
          },
          {
              "title_tr": "Sosluklar",
              "title_en": "Sosluklar",
              "slug": "ahsap-sosluklar",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/sosluklar.jpg"
          },
          {
              "title_tr": "Tepsiler",
              "title_en": "Tepsiler",
              "slug": "ahsap-tepsiler",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/tepsiler.jpg"
          },
          {
              "title_tr": "Yapboz Serisi",
              "title_en": "Yapboz Serisi",
              "slug": "ahsap-yapboz-serisi",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/yapboz-serisi.jpg"
          },
          {
              "title_tr": "Yardımcı Ürünler",
              "title_en": "Auxiliary Products",
              "slug": "ahsap-yardimci-urunler",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/yardimci-urunler.jpg"
          },
          {
              "title_tr": "Çatal, Bıçak ve Kaşık Setleri",
              "title_en": "Cutlery & Flatware Sets",
              "slug": "ahsap-catal-bicak-ve-kasik-setleri",
              "parent": "ahsap-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu/catal-bicak-ve-kasik-setleri.jpg"
          },
          {
              "title_tr": "Polikarbonat Ürünler",
              "title_en": "Polycarbonate Products",
              "slug": "polikarbonat-urunler",
              "imageUrl": "/profinoks/products/horeca-setustu/polikarbonat-urunler.jpg"
          },
          {
              "title_tr": "Tek Kullanımlık Ürünler",
              "title_en": "Disposable Products",
              "slug": "polikarbonat-tek-kullanimlik-urunler",
              "parent": "polikarbonat-urunler",
              "imageUrl": "/profinoks/products/horeca-setustu/polikarbonat-urunler/tek-kullanimlik-urunler.jpg"
          },
          {
              "title_tr": "Çok Kullanımlık Ürünler",
              "title_en": "Reusable Products",
              "slug": "polikarbonat-cok-kullanimlik-urunler",
              "parent": "polikarbonat-urunler",
              "imageUrl": "/profinoks/products/horeca-setustu/polikarbonat-urunler/cok-kullanimlik-urunler.jpg"
          },
          {
              "title_tr": "Toprak Grubu",
              "title_en": "Earthenware & Clay Group",
              "slug": "toprak-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/toprak-grubu.jpg"
          }
,
          {
              "title_tr": "Döküm Grubu",
              "title_en": "Cast Iron Group",
              "slug": "dokum-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/dokum-grubu.jpg"
          },
          {
              "title_tr": "Altınbaşak Döküm",
              "title_en": "Altınbaşak Cast Iron",
              "slug": "dokum-altinbasak-dokum",
              "parent": "dokum-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/dokum-grubu/altinbasak-dokum.jpg"
          },
          {
              "title_tr": "Melamin Grubu",
              "title_en": "Melamine Group",
              "slug": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu.jpg"
          },
          {
              "title_tr": "Baby Life",
              "title_en": "Baby Life",
              "slug": "melamin-baby-life",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/baby-life.jpg"
          },
          {
              "title_tr": "Bergama",
              "title_en": "Bergama",
              "slug": "melamin-bergama",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/bergama.jpg"
          },
          {
              "title_tr": "Bermuda",
              "title_en": "Bermuda",
              "slug": "melamin-bermuda",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/bermuda.jpg"
          },
          {
              "title_tr": "Black",
              "title_en": "Black",
              "slug": "melamin-black",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/black.jpg"
          },
          {
              "title_tr": "Buffet Service",
              "title_en": "Buffet Service",
              "slug": "melamin-buffet-service",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/buffet-service.jpg"
          },
          {
              "title_tr": "Carre",
              "title_en": "Carre",
              "slug": "melamin-carre",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/carre.jpg"
          },
          {
              "title_tr": "Classic",
              "title_en": "Classic",
              "slug": "melamin-classic",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/classic.jpg"
          },
          {
              "title_tr": "Crown",
              "title_en": "Crown",
              "slug": "melamin-crown",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/crown.jpg"
          },
          {
              "title_tr": "Hospital Service",
              "title_en": "Hospital Service",
              "slug": "melamin-hospital-service",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/hospital-service.jpg"
          },
          {
              "title_tr": "International",
              "title_en": "International",
              "slug": "melamin-international",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/international.jpg"
          },
          {
              "title_tr": "Nora",
              "title_en": "Nora",
              "slug": "melamin-nora",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/nora.jpg"
          },
          {
              "title_tr": "Polycarbonate",
              "title_en": "Polycarbonate",
              "slug": "melamin-polycarbonate",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/polycarbonate.jpg"
          },
          {
              "title_tr": "Selfservice",
              "title_en": "Selfservice",
              "slug": "melamin-selfservice",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/selfservice.jpg"
          },
          {
              "title_tr": "Serving Trays",
              "title_en": "Serving Trays",
              "slug": "melamin-serving-trays",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/serving-trays.jpg"
          },
          {
              "title_tr": "Soft",
              "title_en": "Soft",
              "slug": "melamin-soft",
              "parent": "melamin-grubu",
              "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu/soft.jpg"
          },
          {
              "title_tr": "Açık Büfe Teşhir",
              "title_en": "Open Buffet Display",
              "slug": "acik-bufe-teshir",
              "imageUrl": "/profinoks/products/horeca-setustu/acik-bufe-teshir/AL-72401-1_Döner_Sosluk_Reçellik_Standı_-_72_li_3006-5006_Model.jpg"
          }
      ]
    },
  { 
    id: 17, 
    title_tr: "ÇAMAŞIRHANE EKİPMANLARI", 
    title_en: "LAUNDRY EQUIPMENT",
    slug: "camasirhane-ekipmanlari", 
    imageUrl: "/profinoks/products/camasirhane-ekipmanlari.jpg", 
    href: "/products/camasirhane-ekipmanlari", 
    description_tr: "Endüstriyel çamaşır yıkama ve kurutma makineleri.",
    description_en: "Industrial washing and drying machines.", 
    subCategories: [
      { title_tr: "Bantlı Silindir Ütü Makinaları", title_en: "Belt Cylinder Ironing Machines", slug: "camasirhane-bantli-silindir-utu-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/bantli-silindir-utu-makinalari/Electrolux_Professional_-_IB5730-F_Bantlı_Silindir_Ütü_Makinesi__700_mm_x_3000_mm.jpg" },
      { title_tr: "Hijyenik Bariyerli Çamaşır Yıkama Sıkma Makinaları", title_en: "Hygienic Barrier Washer Extractors", slug: "hijyenik-bariyerli-camasir-yikama-sikma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/hijyenik-bariyerli-camasir-yikama-sikma-makinalari/Electrolux_Professional_WB6-110_Hijyenik_Bariyerli_Çamaşır_Yıkama_Sıkma_Makinesı_110_kg._-_Line_6000_seri.jpg" },
      { title_tr: "Kombi Çamaşır Yıkama Sıkma Kurutma Makinaları", title_en: "Combined Washer Dryers", slug: "kombi-camasir-yikama-sikma-kurutma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/kombi-camasir-yikama-sikma-kurutma-makinalari/PRF-KÇYSKME_4.0.2020_Kombi_Çamaşır_Yıkama_Sıkma_Kurutma_Makinası_2020_Kg..jpg" },
      { title_tr: "Kurutma Dolapları", title_en: "Drying Cabinets", slug: "kurutma-dolapları", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/kurutma-doplari/Electrolux_Professional_-_DC6-10HP_Kurutma_Dolabı_1395_mm..jpg" },
      { title_tr: "Paskala Ütüler", title_en: "Ironing Boards (Paskala)", slug: "paskala-utuler", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/paskala-utuler/PRF-PÜM_0022_Kendinden_Kazanlı_Paskala_Ütü_Makinası_140_x_45_x_90_cm.jpg" },
      { title_tr: "Pres Ütüler", title_en: "Press Irons", slug: "pres-utuler", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/pres-utuler/PRF-PÜM_0021_Endüstriyel_Tip_Pres_Ütü_Makinası_145_x_135_x_145_cm.jpg" },
      { title_tr: "Çamaşır Kurutma Makinaları", title_en: "Laundry Drying Machines", slug: "camasirhane-camasir-kurutma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/camasir-kurutma-makinalari/Electrolux_Professional_-_myPRO_-_TE1120HP_Yarı_Endüstriyel_Kurutma_Makinesi_8_kg..jpg" },
      { title_tr: "Çamaşır Yıkama Sıkma Makinaları", title_en: "Washer Extractors", slug: "camasirhane-camasir-yikama-sikma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/camasir-yikama-sikma-makinalari/Electrolux_Professional_-_myPRO_-_PDSTP10S_MYPRO_ÇAMAŞIR_YIKAMASIKMA_MAKİNELERİ_İÇİN_ALT_BAZA.jpg" },
      { title_tr: "Çamaşırhane Arabaları", title_en: "Laundry Trolleys", slug: "camasirhane-arabalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/camasirhane-arabalari/ASKILI_KIYAFET_ARABASI_67_x_152_x_175_cm.jpeg" },
    ] 
  },
  { 
    id: 18, 
    title_tr: "AHŞAP ÜRÜNLER", 
    title_en: "WOODEN PRODUCTS",
    slug: "ahsap-urunler", 
    imageUrl: "/profinoks/products/ahsap-urunler.jpg", 
    href: "/products/ahsap-urunler", 
    description_tr: "Modern ve şık ahşap mutfak ve servis ekipmanları.",
    description_en: "Modern and stylish wooden kitchen and service equipment.", 
    subCategories: [
      { title_tr: "Ahşap Banket Gurubu Tepsi Arabaları", title_en: "Wooden Banquet Tray Trolleys", slug: "ahsap-banket-gurubu-tepsi-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Banket Gurubu Tepsi Arabaları/PRF.1755 Tepsi Arabası Ölçüler En 46 cm  Boy 63 cm  Yükseklik 163 cm.png" },
      { title_tr: "Ahşap Flambe Arabaları", title_en: "Wooden Flambe Trolleys", slug: "ahsap-flambe-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Flambe Arabaları/PRF.106 Flambé Arabası – Profesyonel Ölçüler En 60 cm  Boy 117 cm  Yükseklik 92 cm.png" },
      { title_tr: "Ahşap Kat Arabaları", title_en: "Wooden Housekeeping Trolleys", slug: "ahsap-kat-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Kat Arabaları/PRF.1410 K Kat Arabası (Kapaklı) Ölçüler En 55 cm  Boy 145 cm  Yükseklik 130 cm.png" },
      { title_tr: "Ahşap Oda Servis Arabaları", title_en: "Wooden Room Service Trolleys", slug: "ahsap-oda-servis-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Oda Servis Arabaları/PRF.1455-P Isıtma Kutusu İstasyonu (Paslanmaz Çelik) Ölçüler En 49 cm  Boy 100 cm  Yükseklik 150 cm.png" },
      { title_tr: "Ahşap Servantlar", title_en: "Wooden Sideboards", slug: "ahsap-servantlar", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Servantlar/PRF.1740 Boş Toplama Arabası Ölçüler En 61 Boy 120 Yükseklik 88 cm.png" },
      { title_tr: "Ahşap Servis Arabaları", title_en: "Wooden Service Trolleys", slug: "ahsap-servis-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Servis Arabaları/PRF.101 Servis Arabası ÖlçülerE55 B 100 Y90 cm.png" },
      { title_tr: "Pasta Teşhir ve Servis Arabaları", title_en: "Cake Display and Service Trolleys", slug: "pasta-teshir-ve-servis-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Pasta Teşhir ve Servis Arabaları/PRF.103.MS Peynir & Tatlı Arabası (Motor Soğutmalı) Ölçüler En 50 cm  Boy 100 cm  Yükseklik 108 cm.png" },
      { title_tr: "Saladbarlar", title_en: "Salad Bars", slug: "saladbarlar", imageUrl: "/profinoks/products/ahsap-urunler/Saladbarlar/PRF.130 SALADBAR ( Üstü Kapaklı) Ölçüler En 70 Boy 155 Yükseklik 90+40 cm.jpg" },
    ] 
  },
  { 
    id: 19, 
    title_tr: "FIRIN MAKİNELERİ", 
    title_en: "BAKERY MACHINES",
    slug: "firin-makineleri", 
    imageUrl: "/profinoks/products/firin-makineleri.jpg", 
    href: "/products/firin-makineleri", 
    description_tr: "Ekmek fırınları, hamur makineleri ve pastane ekipmanları.",
    description_en: "Bread ovens, dough machines and pastry equipment."
  },
  { 
    id: 20, 
    title_tr: "ELECTROLUX PROFESSIONAL", 
    title_en: "ELECTROLUX PROFESSIONAL",
    slug: "electrolux-professional", 
    imageUrl: "/profinoks/products/electrolux-professional.jpg", 
    href: "/products/electrolux-professional", 
    description_tr: "Dünyaca ünlü Electrolux Professional pişirme çözümleri, 700XP ve 900XP serileri.",
    description_en: "World-renowned Electrolux Professional cooking solutions, 700XP and 900XP series.",
    subCategories: [
      { title_tr: "700XP Pişiriciler", title_en: "700XP Cooking Equipment", slug: "700xp-pisiriciler", imageUrl: "/profinoks/products/electrolux-professional/700XP Pişiriciler/Griller & Izgaralar/371037 - 700XP Gazlı set üstü ızgara, düz krom pleytli, - 400x730x250 mm.jpg" },
      { title_tr: "900XP Pişiriciler", title_en: "900XP Cooking Equipment", slug: "900xp-pisiriciler", imageUrl: "/profinoks/products/electrolux-professional/900XP Pişiriciler/Griller & Izgaralar/391053 - 900XP Gazlı set üstü ızgara (10kW), düz krom pleytli, eğimli tablalı, termostatik kontrol, demonte sırtlık ve spatula - 400x930x250 mm.jpg" },
    ]
  },
];

export const contactInfo = {
  address: "Firuzköy Mah. Mezarlık Üstü Cad. No:13 34325 Avcılar İstanbul Türkiye",
  phone: ["+90 850 420 87 37", "+90 212 501 51 25"],
  whatsapp: "+90 530 614 07 05",
  whatsappRaw: "905306140705",
  fax: "+90 212 501 51 26",
  emails: ["info@profinoks.com.tr", "proje@profinoks.com.tr"],
  workingHours_tr: "Pazartesi - Cuma: 08:30 - 18:30",
  workingHours_en: "Monday - Friday: 08:30 - 18:30"
};

export const referenceLogos = [
  "/profinoks/references/20-artinox.webp",
  "/profinoks/references/Anadoluefes_logo.jpg",
  "/profinoks/references/Ashan_Logo_S_001.svg",
  "/profinoks/references/Coca-Cola_logo.svg",
  "/profinoks/references/LP10mangal-doener-logo.webp",
  "/profinoks/references/TMSF_logo.svg",
  "/profinoks/references/Trendyol_online.png",
  "/profinoks/references/akkolgruplogo.png",
  "/profinoks/references/anadoluısuzu.png",
  "/profinoks/references/aydın holding.png",
  "/profinoks/references/bybosnak.png",
  "/profinoks/references/cafe duo.jpeg",
  "/profinoks/references/chef bilal.jpg",
  "/profinoks/references/das-miracle-logo.png",
  "/profinoks/references/easycheespizza.jpeg",
  "/profinoks/references/elitcuplogo.webp",
  "/profinoks/references/etit mimarlık.png",
  "/profinoks/references/fabrika tantuni.jpg",
  "/profinoks/references/hereni döner.jpg",
  "/profinoks/references/hereni döner.png",
  "/profinoks/references/heybet döner.png",
  "/profinoks/references/images.png",
  "/profinoks/references/istek okulları.png",
  "/profinoks/references/kahve dünyası.webp",
  "/profinoks/references/karadeniz restaunt özbekistan.jpg",
  "/profinoks/references/leziz esnaf lokantası.png",
  "/profinoks/references/mahsun-usta.png",
  "/profinoks/references/meşhur bursa tulumbacısı.jpg",
  "/profinoks/references/multi pizza.png",
  "/profinoks/references/papamardin.jpeg",
  "/profinoks/references/piacafenorveç.jpeg",
  "/profinoks/references/png-transparent-a1-catering-logo-production-others.png",
  "/profinoks/references/soa.jpg",
  "/profinoks/references/sofra compas.png",
  "/profinoks/references/sofra.png",
  "/profinoks/references/tella kebap.jpg",
  "/profinoks/references/turkuaz catering.jpeg",
  "/profinoks/references/vem ilaç.jpeg",
  "/profinoks/references/İstanbul_Medeniyet_Üniversitesi_logo.svg",
];

export const testimonials = [
  {
    id: 1,
    person: "Thomas Müller",
    role_tr: "Müller Gastronomie GmbH (Almanya)",
    role_en: "Müller Gastronomie GmbH (Germany)",
    quote_tr: "Profinoks ile çalışmaya başladıktan sonra profesyonel mutfak ekipmanları konusundaki bakış açımız tamamen değişti. Ürünlerin malzeme kalitesi, işçilik detayları ve uzun ömürlü yapısı gerçekten güven veriyor. Satış öncesi danışmanlık süreci çok açıklayıcıydı, ihtiyaçlarımıza birebir çözüm sundular. Teslimat ve kurulum aşamasında da son derece düzenli ve titiz davrandılar.",
    quote_en: "Our perspective on professional kitchen equipment completely changed after we started working with Profinoks. The material quality, craftsmanship details, and long-lasting structure of the products really give confidence. The pre-sales consultancy process was very explanatory, offering a one-to-one solution to our needs. They were also extremely organized and meticulous in the delivery and installation phase.",
  },
  {
    id: 2,
    person: "Jean Dupont",
    role_tr: "Hôtel Lumière (Fransa)",
    role_en: "Hôtel Lumière (France)",
    quote_tr: "Otel mutfağımız için tercih ettiğimiz Profinoks ürünlerinden son derece memnunuz. Özellikle paslanmaz çelik kalitesi ve ergonomik tasarımlar günlük operasyonlarimizi ciddi anlamda kolaylaştırdı. Satış sonrası destek ekibi her sorumuza hızlıca dönüş sağladı. Bu kadar profesyonel ve çözüm odaklı bir firma ile çalışmak gerçekten büyük bir avantaj.",
    quote_en: "We are extremely satisfied with the Profinoks products we chose for our hotel kitchen. Especially the stainless steel quality and ergonomic designs have significantly facilitated our daily operations. The after-sales support team responded quickly to all our questions. Working with such a professional and solution-oriented company is really a great advantage.",
  },
  {
    id: 3,
    person: "Luca Bianchi",
    role_tr: "Bianchi Ristorante SRL (İtalya)",
    role_en: "Bianchi Ristorante SRL (Italy)",
    quote_tr: "Profinoks, sadece ürün satan bir firma değil, aynı zamanda mutfak projelerinde gerçek bir çözüm ortağı. Restoranımız için yapılan keşif, projelendirme ve üretim süreci kusursuz ilerledi. Zamanında teslimat, net iletişim ve yüksek kalite standartları sayesinde hiçbir aksaklık yaşamadık. Gönül rahatlığıyla tavsiye ediyorum.",
    quote_en: "Profinoks is not just a company that sells products, but also a true solution partner in kitchen projects. The exploration, planning, and production process for our restaurant went flawlessly. Thanks to timely delivery, clear communication, and high quality standards, we did not experience any setbacks. I recommend them with peace of mind.",
  },
  {
    id: 4,
    person: "Carlos Rodríguez",
    role_tr: "Hostelería Madrid (İspanya)",
    role_en: "Hostelería Madrid (Spain)",
    quote_tr: "Endüstriyel mutfak ekipmanlarında uzun araştırmalar sonucunda Profinoks’u tercih ettik ve doğru karar verdiğimizi net şekilde gördük. Ürünlerin dayanıklılığı, hijyen standartlarına uygunluğu ve şık görünümü beklentimizin üzerindeydi. Ayrıca teknik ekip son derece bilgili ve işine hakim. Müşteri memnuniyetine gerçekten önem veriyorlar.",
    quote_en: "We chose Profinoks after long research in industrial kitchen equipment and clearly saw that we made the right decision. The durability of the products, their compliance with hygiene standards, and their stylish appearance were above our expectations. Also, the technical team is extremely knowledgeable and proficient in their work. They really care about customer satisfaction.",
  },
];

export const mainNavItems = [
  { label_tr: "Ana Sayfa", label_en: "Home Page", path: "/", translationKey: "nav.home" },
  { label_tr: "Kurumsal", label_en: "Corporate", path: "/corporate", translationKey: "nav.corporate" },
  { label_tr: "Ürünler", label_en: "Products", path: "/products", translationKey: "nav.products" },
  { label_tr: "Referanslar", label_en: "References", path: "/references", translationKey: "nav.references" },
  { label_tr: "Projeler", label_en: "Projects", path: "/projects", translationKey: "nav.projects" },
  { label_tr: "Haberler", label_en: "News", path: "/news", translationKey: "nav.news" },
  { label_tr: "İletişim", label_en: "Contact", path: "/contact", translationKey: "nav.contact" },
];

export const projectImages = [
  "/profinoks/projects/1.jpg", "/profinoks/projects/2.jpg", "/profinoks/projects/3.jpg", "/profinoks/projects/4.jpg",
  "/profinoks/projects/5.jpg", "/profinoks/projects/6.jpg", "/profinoks/projects/7.jpg", "/profinoks/projects/8.jpg",
  "/profinoks/projects/9.jpg", "/profinoks/projects/10.jpg", "/profinoks/projects/11.jpg", "/profinoks/projects/12.jpg",
  "/profinoks/projects/14.jpeg", "/profinoks/projects/15.jpg", "/profinoks/projects/16.jpg", "/profinoks/projects/17.jpg",
  "/profinoks/projects/18.jpg", "/profinoks/projects/19.jpg", "/profinoks/projects/20.jpg", "/profinoks/projects/21.jpg",
  "/profinoks/projects/22.jpg", "/profinoks/projects/23.jpg", "/profinoks/projects/24.jpg", "/profinoks/projects/25.jpg",
  "/profinoks/projects/26.jpg", "/profinoks/projects/27.jpg", "/profinoks/projects/28.jpg", "/profinoks/projects/29.jpg",
  "/profinoks/projects/30.jpg", "/profinoks/projects/31.jpeg", "/profinoks/projects/32.jpg", "/profinoks/projects/33.jpg",
  "/profinoks/projects/34.jpg", "/profinoks/projects/35.jpg", "/profinoks/projects/36.jpg", "/profinoks/projects/37.jpg",
  "/profinoks/projects/38.jpg", "/profinoks/projects/39.jpg", "/profinoks/projects/40.jpg", "/profinoks/projects/41.jpg",
  "/profinoks/projects/42.jpg", "/profinoks/projects/43.jpg", "/profinoks/projects/44.jpg", "/profinoks/projects/45.jpg",
  "/profinoks/projects/46.jpg", "/profinoks/projects/47.jpg", "/profinoks/projects/48.jpg", "/profinoks/projects/49.jpg",
  "/profinoks/projects/50.jpg", "/profinoks/projects/51.jpg", "/profinoks/projects/52.jpg", "/profinoks/projects/53.jpg",
  "/profinoks/projects/54.jpg", "/profinoks/projects/55.jpg", "/profinoks/projects/56.jpg", "/profinoks/projects/57.jpg",
  "/profinoks/projects/58.jpg", "/profinoks/projects/59.jpg", "/profinoks/projects/60.jpg", "/profinoks/projects/61.jpg",
  "/profinoks/projects/62.jpg", "/profinoks/projects/63.jpg", "/profinoks/projects/64.jpeg", "/profinoks/projects/65.jpg",
  "/profinoks/projects/66.jpg", "/profinoks/projects/67.jpg", "/profinoks/projects/68.jpg", "/profinoks/projects/69.jpg",
  "/profinoks/projects/70.jpg", "/profinoks/projects/71.jpg", "/profinoks/projects/72.jpg", "/profinoks/projects/73.jpg",
  "/profinoks/projects/74.jpeg", "/profinoks/projects/75.jpg", "/profinoks/projects/76.jpg", "/profinoks/projects/77.jpg",
  "/profinoks/projects/78.jpg", "/profinoks/projects/79.jpg", "/profinoks/projects/80.jpg", "/profinoks/projects/81.jpg",
  "/profinoks/projects/82.jpg", "/profinoks/projects/83.jpg", "/profinoks/projects/84.jpg", "/profinoks/projects/85.JPG",
  "/profinoks/projects/86.jpg", "/profinoks/projects/87.jpg", "/profinoks/projects/88.jpg", "/profinoks/projects/89.jpg",
  "/profinoks/projects/90.jpg", "/profinoks/projects/91.jpg", "/profinoks/projects/92.jpg", "/profinoks/projects/93.jpg",
  "/profinoks/projects/94.jpg", "/profinoks/projects/95.jpg", "/profinoks/projects/96.jpg", "/profinoks/projects/97.jpg",
  "/profinoks/projects/98.jpg", "/profinoks/projects/99.jpg", "/profinoks/projects/100.jpg", "/profinoks/projects/101.jpg",
  "/profinoks/projects/102.jpg", "/profinoks/projects/103.jpg", "/profinoks/projects/104.jpg", "/profinoks/projects/105.JPEG",
  "/profinoks/projects/106.JPEG", "/profinoks/projects/107.jpg", "/profinoks/projects/108.jpg", "/profinoks/projects/109.jpg",
  "/profinoks/projects/110.jpg", "/profinoks/projects/111.jpg", "/profinoks/projects/112.jpg", "/profinoks/projects/113.jpg",
  "/profinoks/projects/114.jpg", "/profinoks/projects/115.jpg", "/profinoks/projects/116.jpg", "/profinoks/projects/117.jpg",
  "/profinoks/projects/118.jpg", "/profinoks/projects/120.jpg", "/profinoks/projects/121.jpg", "/profinoks/projects/122.jpg",
  "/profinoks/projects/123.jpg", "/profinoks/projects/124.jpg", "/profinoks/projects/125.jpg", "/profinoks/projects/126.jpg",
  "/profinoks/projects/127.jpg", "/profinoks/projects/128.jpg", "/profinoks/projects/129.jpg", "/profinoks/projects/130.jpg",
  "/profinoks/projects/131.jpg", "/profinoks/projects/132.jpg", "/profinoks/projects/133.jpg", "/profinoks/projects/134.jpg"
];

export const megaMenuProducts = {
  "pisiriciler": [
    { id: 1, name_tr: "Seri 700", name_en: "Series 700", slug: "seri-700-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-700-cover.jpg" },
    { id: 2, name_tr: "Seri 730", name_en: "Series 730", slug: "seri-730-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-730-cover.jpg" },
    { id: 3, name_tr: "Seri 900", name_en: "Series 900", slug: "seri-900-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-900-cover.jpg" },
    { id: 4, name_tr: "Seri E 600", name_en: "Series E 600", slug: "seri-e-600-pisirme-ekipmanlari", imageUrl: "/profinoks/products/pisiriciler/seri-e-600-cover.jpg" },
  ],
  "firinlar": [
    { id: 1, name_tr: "Electrolux Professional Fırınlar", name_en: "Electrolux Professional Ovens", slug: "electrolux-firinlar", imageUrl: "/profinoks/products/firinlar/electrolux-professional-firinlar.jpg" },
    { id: 2, name_tr: "Empero Fırınlar", name_en: "Empero Ovens", slug: "empero-firinlar", imageUrl: "/profinoks/products/firinlar/empero-firinlar.jpg" },
    { id: 3, name_tr: "Rational Fırınlar", name_en: "Rational Ovens", slug: "rational-firinlar", imageUrl: "/profinoks/products/firinlar/rational-firinlar.jpg" },
    { id: 4, name_tr: "Unox Fırınlar", name_en: "Unox Ovens", slug: "unox-firinlar", imageUrl: "/profinoks/products/firinlar/unox-firinlar.jpg" },
    { id: 5, name_tr: "Vital Fırınlar", name_en: "Vital Ovens", slug: "vital-firinlar", imageUrl: "/profinoks/products/firinlar/vital-firinlar.jpg" },
    { id: 6, name_tr: "Zanussi Professional Fırınlar", name_en: "Zanussi Professional Ovens", slug: "zanussi-professional-firinlar", imageUrl: "/profinoks/products/firinlar/Zanussi-Professional-firinlar.jpg" },
    { id: 7, name_tr: "Öztiryakiler Fırınlar", name_en: "Oztiryakiler Ovens", slug: "oztiryakiler-firinlar", imageUrl: "/profinoks/products/firinlar/oztiryakiler-firinlar.jpg" },
    { id: 8, name_tr: "İnoksan Fırınlar", name_en: "Inoksan Ovens", slug: "inoksan-firinlar", imageUrl: "/profinoks/products/firinlar/inoksan-firinlar.jpg" },
  ],
  "bulasik-makineleri": [
    { id: 1, name_tr: "Giyotin Tip Bulaşık Makineleri", name_en: "Hood Type Dishwashers", slug: "giyotin-tip-bulasik-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Giyotin Tip Bulaşık Makineleri/505089_Giyotin_Tip_Bulaşık_Yıkama_Makinesi.jpg" },
    { id: 2, name_tr: "Konveyörlü Bulaşık Makineleri", name_en: "Conveyor Dishwashers", slug: "konveyorlu-bulasik-yikama-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Konveyörlü Bulaşık Yıkama Makineleri/BKE2000L_Konveyörlü_Bulaşık_Yıkama_Makinesi_-_Sol_Girişli.png" },
    { id: 3, name_tr: "Set Altı Bardak Yıkama", name_en: "Undercounter Glass Washer", slug: "set-alti-bardak-yikama-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Set Altı Bardak Yıkama Makineleri/402278_Set_Altı_Bardak_Yıkama_Makinesi.jpg" },
    { id: 4, name_tr: "Set Altı Bulaşık Yıkama", name_en: "Undercounter Dishwasher", slug: "set-alti-bulasik-yikama-makineleri", imageUrl: "/profinoks/products/bulasik-makineleri/Set Altı Bulaşık Yıkama Makineleri/400257_Set_Altı_Bulaşık_Yıkama_Makinesi.jpg" },
  ],
  "hazirlik-makineleri": [
    { id: 1, name_tr: "Adana Kebap Makineleri", name_en: "Adana Kebab Machines", slug: "adana-kebap-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/adana-kebap-makineleri/3001.jpg" },
    { id: 2, name_tr: "Bulama ve Paneleme Makineleri", name_en: "Breading and Battering Machines", slug: "bulama-ve-paneleme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/bulama-ve-paneleme-makineleri/3002.jpg" },
    { id: 3, name_tr: "Ekmek Dilimleme Makineleri", name_en: "Bread Slicing Machines", slug: "ekmek-dilimleme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/ekmek-dilimleme-makineleri/3003.jpg" },
    { id: 4, name_tr: "El Blenderları", name_en: "Hand Blenders", slug: "el-blenderlari", imageUrl: "/profinoks/products/hazirlik-makineleri/el-blenderlari/3013.jpg" },
    { id: 5, name_tr: "Et Kıyma Makineleri", name_en: "Meat Grinders", slug: "et-kiyma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/et-kiyma-makineleri/3060.jpg" },
    { id: 6, name_tr: "Et ve Kemik Testereleri", name_en: "Meat and Bone Saws", slug: "et-ve-kemik-testereleri", imageUrl: "/profinoks/products/hazirlik-makineleri/et-ve-kemik-testereleri/3102.jpg" },
    { id: 7, name_tr: "Gıda Dilimleme Makineleri", name_en: "Food Slicing Machines", slug: "gida-dilimleme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/gida-dilimleme-makineleri/3106.jpg" },
    { id: 8, name_tr: "Gıda Öğütücüleri", name_en: "Food Grinding Machines", slug: "gida-ogutuculeri", imageUrl: "/profinoks/products/hazirlik-makineleri/gida-ogutuculeri/3113.jpg" },
    { id: 9, name_tr: "Hamur Açma Makineleri", name_en: "Dough Sheeters", slug: "hamur-acma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/hamur-acma-makineleri/3120.jpg" },
    { id: 10, name_tr: "Hamur Yoğurma Makineleri", name_en: "Dough Kneading Machines", slug: "hamur-yogurma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/hamur-yogurma-makineleri/3125.jpg" },
    { id: 11, name_tr: "Köfte Şekillendirme Makineleri", name_en: "Meatball Forming Machines", slug: "kofte-sekillendirme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/kofte-sekillendirme-makineleri/3169.jpg" },
    { id: 12, name_tr: "Lokma Dökme Makineleri", name_en: "Lokma Doughnut Machines", slug: "lokma-dokme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/lokma-dokme-makineleri/3170.jpeg" },
    { id: 13, name_tr: "Otomatik Fritözler", name_en: "Automatic Fryers", slug: "otomatik-fritozler", imageUrl: "/profinoks/products/hazirlik-makineleri/otomatik-fritozler/3172.png" },
    { id: 14, name_tr: "Patates Dilimleme Makinesi", name_en: "Potato Slicing Machine", slug: "patates-dilimleme-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/1771948463019_pw7myv.png" },
    { id: 15, name_tr: "Patates Soyma Makineleri", name_en: "Potato Peeling Machines", slug: "patates-soyma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/patates-soyma-makineleri/3174.jpg" },
    { id: 16, name_tr: "Planet Mikserler", name_en: "Planetary Mixers", slug: "planet-mikserler", imageUrl: "/profinoks/products/hazirlik-makineleri/planet-mikserler/3200.jpg" },
    { id: 17, name_tr: "Sebze Doğrama Makineleri", name_en: "Vegetable Cutting Machines", slug: "sebze-dograma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/sebze-dograma-makineleri/3234.jpg" },
    { id: 18, name_tr: "Sebze Yıkama ve Kurutma Makineleri", name_en: "Vegetable Washing and Drying Machines", slug: "sebze-yikama-ve-kurutma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/sebze-yikama-ve-kurutma-makineleri/3292.jpg" },
    { id: 19, name_tr: "Sebze-Et Parçalama Makineleri", name_en: "Vegetable and Meat Shredders", slug: "sebze-et-parcalama-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/sebze-et-parcalama-makineleri/3309.jpg" },
    { id: 20, name_tr: "Soğan Doğrama Makinesi", name_en: "Onion Cutting Machine", slug: "sogan-dograma-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/sogan-dograma-makinesi/13203.jpg" },
    { id: 21, name_tr: "Spiral Hamur Yoğurma Makineleri", name_en: "Spiral Dough Kneaders", slug: "spiral-hamur-yogurma-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/spiral-hamur-yogurma-makineleri/3339.jpg" },
    { id: 22, name_tr: "Tabak Kapatma Makinesi", name_en: "Plate Sealing Machine", slug: "tabak-kapatma-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/tabak-kapatma-makinesi/13200.jpg" },
    { id: 23, name_tr: "Tavuk Kesme Makinesi", name_en: "Chicken Cutting Machine", slug: "tavuk-kesme-makinesi", imageUrl: "/profinoks/products/hazirlik-makineleri/tavuk-kesme-makinesi/3345.jpeg" },
    { id: 24, name_tr: "Tulumba ve Köfte Şekillendirme Makineleri", name_en: "Pastry and Meatball Forming Machines", slug: "tulumba-ve-kofte-sekillendirme-makineleri", imageUrl: "/profinoks/products/hazirlik-makineleri/tulumba-ve-kofte-sekillendirme-makineleri/3346.jpg" },
    { id: 25, name_tr: "Çekmeceli Isıtma Üniteleri", name_en: "Drawer Heating Units", slug: "cekmeceli-isitma-uniteleri", imageUrl: "/profinoks/products/hazirlik-makineleri/cekmeceli-isitma-uniteleri/3350.jpg" },
  ],
  "icecek-makineleri": [
    { id: 1, name_tr: "Bardak Fincan Isıtıcılar", name_en: "Cup and Mug Warmers", slug: "bardak-fincan-isiticilar", imageUrl: "/profinoks/products/icecek-makineleri/bardak-fincan-isiticilar/BFI60 - BARDAK FİNCAN ISITICI.jpg" },
    { id: 2, name_tr: "Espresso Kahve Makineleri", name_en: "Espresso Coffee Machines", slug: "espresso-kahve-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/espresso-kahve-makineleri/Coffee Master Profesyonel Otomatik Espresso Kahve Makinesi - CRM3120 - cm1.jpg" },
    { id: 3, name_tr: "Filtre Kahve Makineleri", name_en: "Filter Coffee Machines", slug: "filtre-kahve-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/filtre-kahve-makineleri/10380 - Animo Excelso Filtre Kahve Makinesi, 1.8 L.jpg" },
    { id: 4, name_tr: "Ice Slush İçecek Makineleri", name_en: "Ice Slush Machines", slug: "ice-slush-icecek-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/ice-slush-icecek-makineleri/SLUSH12.I Mono Ice Slush Granita Milkshake ve Soğuk Meyve Suyu Dispenseri, 12 L, Inox.jpg" },
    { id: 5, name_tr: "Isıtıcılı Sosluklar", name_en: "Heated Sauce Dispensers", slug: "isiticili-sosluklar", imageUrl: "/profinoks/products/icecek-makineleri/isiticili-sosluklar/2'li Isıtıcılı Sosluk sc3.webp" },
    { id: 6, name_tr: "Kahve Değirmenleri", name_en: "Coffee Grinders", slug: "kahve-degirmenleri", imageUrl: "/profinoks/products/icecek-makineleri/kahve-degirmenleri/M2D - MACAP Kahve Değirmeni ONDEMAND beyaz.jpg" },
    { id: 7, name_tr: "Kumda Kahve Makineleri", name_en: "Sand Coffee Machines", slug: "kumda-kahve-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/kumda-kahve-makineleri/Altın Kumda Kahve Makinesi - kf2.jpg" },
    { id: 8, name_tr: "Köpüklü Ayran Dispenserleri", name_en: "Foamy Ayran Dispensers", slug: "kopuklu-ayran-dispenserleri", imageUrl: "/profinoks/products/icecek-makineleri/kopuklu-ayran-dispenserleri/KAM22.DI Panaromik Dijital Köpüklü Ayran Dispenseri, 22 L, Inox.jpg" },
    { id: 9, name_tr: "Soğuk İçecek Dispenserleri", name_en: "Cold Beverage Dispensers", slug: "soguk-icecek-dispenserleri", imageUrl: "/profinoks/products/icecek-makineleri/soguk-icecek-dispenserleri/20.MB Klasik Mono Soğuk İçecek Dispenseri, 20 L, Karıştırıcılı, Siyah.jpg" },
    { id: 10, name_tr: "Su ve Süt Otomatları", name_en: "Water and Milk Dispensers", slug: "su-ve-sut-otomatlari", imageUrl: "/profinoks/products/icecek-makineleri/su-ve-sut-otomatlari/120 Bardak Sıcak Su Otomatı su-otomati-tek-lamba.jpg" },
    { id: 11, name_tr: "Sıcak İçecek Dispenserleri", name_en: "Hot Beverage Dispensers", slug: "sicak-icecek-dispenserleri", imageUrl: "/profinoks/products/icecek-makineleri/sicak-icecek-dispenserleri/HOT GOLD SC06 Sıcak Çikolata ve Sahlep Makinesi, 6 L, Gold.jpg" },
    { id: 12, name_tr: "Çay Kazanları", name_en: "Tea Boilers", slug: "cay-kazanlari", imageUrl: "/profinoks/products/icecek-makineleri/cay-kazanlari/15 Model Elektrikli Çay Ocağı 14 lt - k30.jpg" },
    { id: 13, name_tr: "Çay Makineleri", name_en: "Tea Machines", slug: "cay-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/cay-makineleri/120 Bardak Deluxe Çay Makinesi.jpg" },
    { id: 14, name_tr: "Çikolata Sosluğu", name_en: "Chocolate Sauce Machine", slug: "cikolata-soslugu", imageUrl: "/profinoks/products/icecek-makineleri/cikolata-soslugu/Çikolata Sosluğu 2,8 lt sc1.webp" },
    { id: 15, name_tr: "Çorba Isıtıcılar", name_en: "Soup Warmers", slug: "corba-isiticilar", imageUrl: "/profinoks/products/icecek-makineleri/corba-isiticilar/Bakır Prestij Model Maksi Çorba Isıtıcı 13 lt cb15.jpg" },
    { id: 16, name_tr: "İçecek Hazırlık Makineleri", name_en: "Beverage Preparation Machines", slug: "icecek-hazirlik-makineleri", imageUrl: "/profinoks/products/icecek-makineleri/icecek-hazirlik-makineleri/Bar Blender Pro bb02.jpg" },
  ],
  "self-servis": [
    { id: 1, name_tr: "Kuver Üniteleri", name_en: "Cutlery Units", slug: "kuver-uniteleri", imageUrl: "/profinoks/products/self-servis/kuver-uniteleri/kuver-uniteleri.jpg" },
    { id: 2, name_tr: "Standart Benmariler", name_en: "Standard Bain-Maries", slug: "standart-benmariler", imageUrl: "/profinoks/products/self-servis/standart-benmariler/standart-benmariler.jpg" },
    { id: 3, name_tr: "Soğuk Servis Üniteleri", name_en: "Cold Service Units", slug: "soguk-servis-uniteleri", imageUrl: "/profinoks/products/self-servis/soguk-servis-uniteleri/soguk-servis-uniteleri.jpg" },
    { id: 4, name_tr: "Kule Tip Soğuk Dolaplar", name_en: "Tower Type Cold Cabinets", slug: "kule-tip-soguk-dolaplar", imageUrl: "/profinoks/products/self-servis/kule-tip-soguk-dolaplar/kule-tip-soguk-dolaplar.jpg" },
    { id: 5, name_tr: "Nötr Servis Üniteleri", name_en: "Neutral Service Units", slug: "notr-servis-uniteleri", imageUrl: "/profinoks/products/self-servis/notr-servis-uniteleri/notr-servis-uniteleri.jpg" },
    { id: 6, name_tr: "Köşe Servis Üniteleri", name_en: "Corner Service Units", slug: "kose-servis-uniteleri", imageUrl: "/profinoks/products/self-servis/kose-servis-uniteleri/kose-servis-uniteleri.jpg" },
    { id: 7, name_tr: "Kasa Tezgahları", name_en: "Cashier Counters", slug: "kasa-tezgahlari", imageUrl: "/profinoks/products/self-servis/kasa-tezgahlari/kasa-tezgahlari.jpg" },
    { id: 8, name_tr: "Eko Benmariler", name_en: "Eco Bain-Maries", slug: "eko-benmariler", imageUrl: "/profinoks/products/self-servis/eko-benmariler/eko-benmariler.jpg" },
    { id: 9, name_tr: "Orta Tip Ahşap Kaplamalı Saladbarlar", name_en: "Central Wood Veneered Salad Bars", slug: "orta-tip-ahsap-kaplamali-saladbarlar", imageUrl: "/profinoks/products/self-servis/orta-tip-ahsap-kaplamali-saladbarlar/orta-tip-ahsap-kaplamali-saladbarlar.jpg" },
    { id: 10, name_tr: "Orta Tip Ahşap Kaplamalı Benmariler", name_en: "Central Wood Veneered Bain-Maries", slug: "orta-tip-ahsap-kaplamali-benmariler", imageUrl: "/profinoks/products/self-servis/orta-tip-ahsap-kaplamali-benmariler/orta-tip-ahsap-kaplamali-benmariler.jpg" },
    { id: 11, name_tr: "Montajlanmış Self Servis Hatları", name_en: "Assembled Self-Service Lines", slug: "montajlanmis-self-servis-hatlari", imageUrl: "/profinoks/products/self-servis/montajlanmis-self-servis-hatlari/montajlanmis-self-servis-hatlari.jpg" }
  ],
  "acik-bufe": [
    { id: 1, name_tr: "Ekmek Servis Üniteleri", name_en: "Bread Service Units", imageUrl: "/profinoks/products/acik-bufe/PRF-BL 100 Ekmek Servis Ünitesi 1000x1000x900 mm.jpg" },
    { id: 2, name_tr: "Soğuk Servis Üniteleri", name_en: "Cold Service Units", imageUrl: "/profinoks/products/acik-bufe/PRF-CL 160G Soğuk Servis Ünitesi (Granite Yüzey) 1600x1000x900 mm.jpg" },
    { id: 3, name_tr: "Sıcak Servis Üniteleri (Chafing Dish)", name_en: "Hot Service Units (Chafing Dish)", imageUrl: "/profinoks/products/acik-bufe/PRF-DL162 Sıcak Servis Ünitesi  Chafing Dish 1600x1000x900 mm.jpg" },
    { id: 4, name_tr: "Sıcak Servis Üniteleri (Benmari)", name_en: "Hot Service Units (Bain-Marie)", imageUrl: "/profinoks/products/acik-bufe/PRF-HL 133 Sıcak Servis Ünitesi (Benmari) 1300x1000x900 mm.jpg" },
    { id: 5, name_tr: "Isıtmalı Tabak Üniteleri", name_en: "Heated Plate Units", imageUrl: "/profinoks/products/acik-bufe/PRF-PL 070 Isıtmalı Yaylı Tabak Ünitesi 700x1000x900 mm.jpg" },
    { id: 6, name_tr: "Çorba Servis Üniteleri", name_en: "Soup Service Units", imageUrl: "/profinoks/products/acik-bufe/PRF-SL161G Çorba Servis Ünitesi (Çorbalıklı) 1600x1000x900 mm.jpg" },
    { id: 7, name_tr: "Show Servis Üniteleri", name_en: "Show Service Units", imageUrl: "/profinoks/products/acik-bufe/PRF-WL 130 Show Servis Ünitesi 1300x1000x900 mm.jpg" },
  ],
  "buzdolaplar-ve-dondurucular": [
    { id: 1, name_tr: "Buz Makineleri", name_en: "Ice Machines", slug: "buz-makineleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Buz Makineleri/Kastel KP 175-75 Buz Makinesi 175 Kg-gün Kapasiteli.jpg" },
    { id: 2, name_tr: "Buzdolaplar ve Dondurucular", name_en: "Refrigerators and Freezers", slug: "refrigerators-and-freezers", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Buzdolaplar ve Dondurucular/DİKEY TİP BUZDOLAPLAR/PRF.208420012000 DİKEY TİP ÇİFT KAPILI BUZDOLABI +2, +8C°.png" },
    { id: 3, name_tr: "Dondurma Makineleri", name_en: "Ice Cream Machines", slug: "dondurma-makineleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Dondurma Makineleri/Dikey Tip Dondurma Makineleri/Vbf-50-160 Dikey Dondurma Makinesi 50-160 Lt, 605x930x1330 mm..jpg" },
    { id: 4, name_tr: "Dondurma Teşhir Vitrinleri", name_en: "Ice Cream Display Cabinets", slug: "dondurma-teshir-vitrinleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Dondurma Teşhir Vitrinleri/Aqua Serisi/Aqua-12 Dondurma Teşhir Vitrini 12 x 5 Lt, 1212x1129x1321 mm..png" },
    { id: 5, name_tr: "Su Sebilleri", name_en: "Water Dispensers", slug: "su-sebilleri", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Su Sebilleri/P.SBL.80.01 Su Sebili (İç Dış Paslanmaz) 80 Lt, 600x500x1480 mm..jpg" },
    { id: 6, name_tr: "Teşhir Dolapları", name_en: "Display Cabinets", slug: "teshir-dolaplari", imageUrl: "/profinoks/products/buzdolaplar-ve-dondurucular/Teşhir Dolapları/P.BCPD.80.01.P Bombe Camlı Dik Tip Pasta Teşhir Dolabı Soğutmalı 800x700x1300 mm..jpg" },
  ],
  "soguk-odalar": [
    { id: 101, name_tr: "Panel Tipi Soğuk Oda, 150x150 cm", name_en: "Panel Type Cold Room, 150x150 cm", imageUrl: "/profinoks/products/soguk-odalar/panel_tipi_souk_oda_05_c_150x150_cm.jpg" },
  ],
  "tezgahlar": [
      {
          "id": 1,
          "name_tr": "Bulaşık Makinası Giriş Tezgahı Taban Rafsız Tek Evyeli (400x500x250 Evyeli)",
          "name_en": "Dishwasher Inlet Table without Bottom Shelf Single Sink (400x500x250 Sink)",
          "slug": "bulasik-makinasi-giris-tezgahi-taban-rafsiz-tek-evyeli-400x500x250-evyeli",
          "imageUrl": "/profinoks/products/tezgahlar/bulasik-makinasi-giris-tezgahi-taban-rafsiz-tek-evyeli-400x500x250-evyeli/P.BMGE.75.01_Bulaşık_Makinası_Giriş_Tezgahı_Taban_Rafsız_Tek_Evyeli_400x500x250_Evyeli_800x750x850_mm.jpg"
      },
      {
          "id": 2,
          "name_tr": "Bulaşık Makinası Giriş Tezgahı Taban Rafsız İki Evyeli (400x500x250 Evyeli)",
          "name_en": "Dishwasher Inlet Table without Bottom Shelf Double Sink (400x500x250 Sink)",
          "slug": "bulasik-makinasi-giris-tezgahi-taban-rafsiz-iki-evyeli-400x500x250-evyeli",
          "imageUrl": "/profinoks/products/tezgahlar/bulasik-makinasi-giris-tezgahi-taban-rafsiz-iki-evyeli-400x500x250-evyeli/P.BMG2E.75.01_Bulaşık_Makinası_Giriş_Tezgahı_Taban_Rafsız_İki_Evyeli_400x500x250_Evyeli_1400x750x850.jpg"
      },
      {
          "id": 3,
          "name_tr": "Bulaşık Makinası Çıkış Tezgahı Taban Rafsız",
          "name_en": "Dishwasher Outlet Table without Bottom Shelf",
          "slug": "bulasik-makinasi-cikis-tezgahi-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/bulasik-makinasi-cikis-tezgahi-taban-rafsiz/P.BMÇ.75.01_Bulaşık_Makinası_Çıkış_Tezgahı_Taban_Rafsız_800x750x850_mm.jpg"
      },
      {
          "id": 4,
          "name_tr": "Bıçak Steril Dolabı (10 Bıçak)",
          "name_en": "Knife Sterilizer Cabinet (10 Knives)",
          "slug": "bicak-steril-dolabi-10-bicak",
          "imageUrl": "/profinoks/products/tezgahlar/bicak-steril-dolabi-10-bicak/P.BSD.40.01_Bıçak_Steril_Dolabı_10_Bıçak_520x120x630_mm.jpg"
      },
      {
          "id": 5,
          "name_tr": "Dolaplı Çalışma Modülü Çarpma Kapılı Ara Raflı",
          "name_en": "Cupboard Work Unit with Hinged Door and Intermediate Shelf",
          "slug": "dolapli-calisma-modulu-carpma-kapili-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-modulu-carpma-kapili-ara-rafli/P.DTTÇM.60.01_Dolaplı_Çalışma_Modülü_Çarpma_Kapılı_Ara_Raflı_600x600x850_mm.jpg"
      },
      {
          "id": 6,
          "name_tr": "Dolaplı Çalışma Tezgahı Ara Raflı Isıtıcı Modüllü",
          "name_en": "Cupboard Worktable with Intermediate Shelf and Heated Module",
          "slug": "dolapli-calisma-tezgahi-ara-rafli-isitici-modullu",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-ara-rafli-isitici-modullu/P.HÇTT.60.01_Dolaplı_Çalışma_Tezgahı_Ara_Raflı_Isıtıcı_Modüllü_1400x700x850_mm.jpg"
      },
      {
          "id": 7,
          "name_tr": "Dolaplı Çalışma Tezgahı Ara Raflı Önü Açık",
          "name_en": "Cupboard Worktable Open Front with Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-ara-rafli-onu-acik",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-ara-rafli-onu-acik/P.DTTA.60.01_Dolaplı_Çalışma_Tezgahı_Ara_Raflı_Önü_Açık_900x600x850_mm.jpg"
      },
      {
          "id": 8,
          "name_tr": "Dolaplı Çalışma Tezgahı Ara Rafsız Önü Açık",
          "name_en": "Cupboard Worktable Open Front without Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-ara-rafsiz-onu-acik",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-ara-rafsiz-onu-acik/P.DTA.60.01_Dolaplı_Çalışma_Tezgahı_Ara_Rafsız_Önü_Açık_900x600x850_mm.jpg"
      },
      {
          "id": 9,
          "name_tr": "Dolaplı Çalışma Tezgahı Sürgü Kapılı Ara Raflı",
          "name_en": "Cupboard Worktable with Sliding Doors and Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-surgu-kapili-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-surgu-kapili-ara-rafli/P.DÇSA.60.01_Dolaplı_Çalışma_Tezgahı_Sürgü_Kapılı_Ara_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 10,
          "name_tr": "Dolaplı Çalışma Tezgahı Sürgü Kapılı Ara Rafsız",
          "name_en": "Cupboard Worktable with Sliding Doors without Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-surgu-kapili-ara-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-surgu-kapili-ara-rafsiz/P.DÇS.60.01_Dolaplı_Çalışma_Tezgahı_Sürgü_Kapılı_Ara_Rafsız_900x600x850_mm.jpg"
      },
      {
          "id": 11,
          "name_tr": "Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Sürgü Kapılı Tek Evyeli",
          "name_en": "Cupboard Worktable with Upstand, Sliding Doors, Single Sink without Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili-tek-evyeli",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili-tek-evyeli/P.DÇSE.60.01_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Sürgü_Kapılı_400x400x250_Tek_Evyeli_1200x600x850_mm.jpg"
      },
      {
          "id": 12,
          "name_tr": "Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Çarpma Kapılı Tek Evyeli",
          "name_en": "Cupboard Worktable with Upstand, Hinged Doors, Single Sink without Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili-tek-evyeli",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili-tek-evyeli/P.DÇÇE.60.01_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Çarpma_Kapılı_400x400x250_Tek_Evyeli_600x600x850_mm.jpg"
      },
      {
          "id": 13,
          "name_tr": "Dolaplı Çalışma Tezgahı Sırtlı Devrilir Ekmeklik Modülü",
          "name_en": "Cupboard Worktable with Upstand and Tilting Bread Bin Module",
          "slug": "dolapli-calisma-tezgahi-sirtli-devrilir-ekmeklik-modulu",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-sirtli-devrilir-ekmeklik-modulu/P.DÇTDE.60.01_Dolaplı_Çalışma_Tezgahı_Sırtlı_Devrilir_Ekmeklik_Modülü_600x600x850_mm.jpg"
      },
      {
          "id": 14,
          "name_tr": "Dolaplı Çalışma Tezgahı Çarpma Kapılı Ara Raflı",
          "name_en": "Cupboard Worktable with Hinged Doors and Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-carpma-kapili-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-carpma-kapili-ara-rafli/P.DTTÇ.60.01_Dolaplı_Çalışma_Tezgahı_Çarpma_Kapılı_Ara_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 15,
          "name_tr": "Dolaplı Çalışma Tezgahı Çarpma Kapılı Ara Rafsız",
          "name_en": "Cupboard Worktable with Hinged Doors without Intermediate Shelf",
          "slug": "dolapli-calisma-tezgahi-carpma-kapili-ara-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/dolapli-calisma-tezgahi-carpma-kapili-ara-rafsiz/P.DTÇ.60.01_Dolaplı_Çalışma_Tezgahı_Çarpma_Kapılı_Ara_Rafsız_900x600x850_mm.jpg"
      },
      {
          "id": 16,
          "name_tr": "Duvar Dolabı Sürgü Kapılı Ara Raflı",
          "name_en": "Wall Cupboard with Sliding Doors and Intermediate Shelf",
          "slug": "duvar-dolabi-surgu-kapili-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-surgu-kapili-ara-rafli/P.DDSA.40.01_Duvar_Dolabı_Sürgü_Kapılı_Ara_Raflı_900x400x600_mm.jpg"
      },
      {
          "id": 17,
          "name_tr": "Duvar Dolabı Sürgü Kapılı Ara Rafsız",
          "name_en": "Wall Cupboard with Sliding Doors without Intermediate Shelf",
          "slug": "duvar-dolabi-surgu-kapili-ara-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-surgu-kapili-ara-rafsiz/P.DDS.40.01_Duvar_Dolabı_Sürgü_Kapılı_Ara_Rafsız_900x400x600_mm.jpg"
      },
      {
          "id": 18,
          "name_tr": "Duvar Dolabı Çarpma Kapılı Ara Raflı",
          "name_en": "Wall Cupboard with Hinged Doors and Intermediate Shelf",
          "slug": "duvar-dolabi-carpma-kapili-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-carpma-kapili-ara-rafli/P.DDÇA.40.01_Duvar_Dolabı_Çarpma_Kapılı_Ara_Raflı_900x400x600_mm.jpg"
      },
      {
          "id": 19,
          "name_tr": "Duvar Dolabı Çarpma Kapılı Ara Rafsız",
          "name_en": "Wall Cupboard with Hinged Doors without Intermediate Shelf",
          "slug": "duvar-dolabi-carpma-kapili-ara-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-carpma-kapili-ara-rafsiz/P.DDÇ.40.01_Duvar_Dolabı_Çarpma_Kapılı_Ara_Rafsız_900x400x600_mm.jpg"
      },
      {
          "id": 20,
          "name_tr": "Duvar Dolabı Ön Açık Ara Raflı",
          "name_en": "Wall Cupboard Open Front with Intermediate Shelf",
          "slug": "duvar-dolabi-on-acik-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-on-acik-ara-rafli/P.DDA.40.01_Duvar_Dolabı_Ön_Açık_Ara_Raflı_900x400x600_mm.jpg"
      },
      {
          "id": 21,
          "name_tr": "Duvar Dolabı Ön Açık Ara Rafsız",
          "name_en": "Wall Cupboard Open Front without Intermediate Shelf",
          "slug": "duvar-dolabi-on-acik-ara-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-dolabi-on-acik-ara-rafsiz/P.DD.40.01_Duvar_Dolabı_Ön_Açık_Ara_Rafsız_900x400x600_mm.jpg"
      },
      {
          "id": 22,
          "name_tr": "Duvar Rafı Tek Katlı",
          "name_en": "Single Tier Wall Shelf",
          "slug": "duvar-rafi-tek-katli",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-rafi-tek-katli/P.DVR1.30.01_Duvar_Rafı_Tek_Katlı_800x300x30_mm.jpg"
      },
      {
          "id": 23,
          "name_tr": "Duvar Rafı Çift Katlı",
          "name_en": "Double Tier Wall Shelf",
          "slug": "duvar-rafi-cift-katli",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-rafi-cift-katli/P.DVR2.30.01_Duvar_Rafı_Çift_Katlı_800x300x30_mm.jpg"
      },
      {
          "id": 24,
          "name_tr": "Duvar Rafı Üç Katlı",
          "name_en": "Triple Tier Wall Shelf",
          "slug": "duvar-rafi-uc-katli",
          "imageUrl": "/profinoks/products/tezgahlar/duvar-rafi-uc-katli/P.DVR3.30.01_Duvar_Rafı_Üç_Katlı_800x300x30_mm.jpg"
      },
      {
          "id": 25,
          "name_tr": "Ekmek Dolabı",
          "name_en": "Bread Cabinet",
          "slug": "ekmek-dolabi",
          "imageUrl": "/profinoks/products/tezgahlar/ekmek-dolabi/P.EKD.40.04_Ekmek_Dolabı_1000x500x1600_mm.jpg"
      },
      {
          "id": 26,
          "name_tr": "Galoş Bone Dolabı",
          "name_en": "Shoe Cover & Hairnet Cabinet",
          "slug": "galos-bone-dolabi",
          "imageUrl": "/profinoks/products/tezgahlar/galos-bone-dolabi/P.GBD.01_Galoş_Bone_Dolabı_500x250x400_mm.jpg"
      },
      {
          "id": 27,
          "name_tr": "Galoş Bone Dolabı, Çöp Hazneli",
          "name_en": "Shoe Cover & Hairnet Cabinet with Waste Bin",
          "slug": "galos-bone-dolabi-cop-hazneli",
          "imageUrl": "/profinoks/products/tezgahlar/galos-bone-dolabi-cop-hazneli/P.GBDÇ.01_Galoş_Bone_Dolabı_Çöp_Hazneli_500x250x800_mm.jpg"
      },
      {
          "id": 28,
          "name_tr": "Garnitürlük",
          "name_en": "Garnish Dispenser",
          "slug": "garniturluk",
          "imageUrl": "/profinoks/products/tezgahlar/garniturluk/P.GRN.30.01_Garnitürlük_GN1-4x100mm_küvetli_900x300x200_mm.jpg"
      },
      {
          "id": 29,
          "name_tr": "Hareketli Çalışma Tezgahı Ara Raflı",
          "name_en": "Mobile Worktable with Intermediate Shelf",
          "slug": "hareketli-calisma-tezgahi-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/hareketli-calisma-tezgahi-ara-rafli/P.HÇTTA.60.01_Hareketli_Çalışma_Tezgahı_Ara_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 30,
          "name_tr": "Hareketli Çalışma Tezgahı Taban Raflı",
          "name_en": "Mobile Worktable with Bottom Shelf",
          "slug": "hareketli-calisma-tezgahi-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/hareketli-calisma-tezgahi-taban-rafli/P.HÇTT.60.01_Hareketli_Çalışma_Tezgahı_Taban_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 31,
          "name_tr": "Kazan Kabul Tezgahı",
          "name_en": "Pot Reception Table",
          "slug": "kazan-kabul-tezgahi",
          "imageUrl": "/profinoks/products/tezgahlar/kazan-kabul-tezgahi/P.KKT.60.01_Kazan_Kabul_Tezgahı_1000x800x550360_mm.jpg"
      },
      {
          "id": 32,
          "name_tr": "Kazan Yıkama Tezgahı",
          "name_en": "Pot Washing Table",
          "slug": "kazan-yikama-tezgahi",
          "imageUrl": "/profinoks/products/tezgahlar/kazan-yikama-tezgahi/P.KYT.60.01_Kazan_Yıkama_Tezgahı_1000x800x550360_mm.jpg"
      },
      {
          "id": 33,
          "name_tr": "Kepçe Askı Borusu",
          "name_en": "Ladle Hanging Rail",
          "slug": "kepce-aski-borusu",
          "imageUrl": "/profinoks/products/tezgahlar/kepce-aski-borusu/P.KAB1.30.01_Kepçe_Askı_Borusu_900x60x20_mm.jpg"
      },
      {
          "id": 34,
          "name_tr": "Mermer Tablalı Çalışma Tezgahı Taban Raflı",
          "name_en": "Worktable with Marble Top & Bottom Shelf",
          "slug": "mermer-tablali-calisma-tezgahi-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/mermer-tablali-calisma-tezgahi-taban-rafli/P.MTÇTT.70.01_Mermer_Tablalı_Çalışma_Tezgahı_Taban_Raflı_900x700x850_mm.jpg"
      },
      {
          "id": 35,
          "name_tr": "Mermer Tablalı Çalışma Tezgahı Taban Rafsız",
          "name_en": "Worktable with Marble Top without Bottom Shelf",
          "slug": "mermer-tablali-calisma-tezgahi-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/mermer-tablali-calisma-tezgahi-taban-rafsiz/P.MTÇT.70.01_Mermer_Tablalı_Çalışma_Tezgahı_Taban_Rafsız_900x700x850_mm.jpg"
      },
      {
          "id": 36,
          "name_tr": "Paspas Yıkama Evyesi",
          "name_en": "Mop Sink",
          "slug": "paspas-yikama-evyesi",
          "imageUrl": "/profinoks/products/tezgahlar/paspas-yikama-evyesi/P.PYE.01_Paspas_Yıkama_Evyesi_600x700x850_mm.jpg"
      },
      {
          "id": 37,
          "name_tr": "Polietilen Tablalı Çalışma Tezgahı Taban Raflı",
          "name_en": "Worktable with Polyethylene Top & Bottom Shelf",
          "slug": "polietilen-tablali-calisma-tezgahi-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/polietilen-tablali-calisma-tezgahi-taban-rafli/P.PTÇTT.60.01_Polietilen_Tablalı_Çalışma_Tezgahı_Taban_Raflı_600x600x850_mm.jpg"
      },
      {
          "id": 38,
          "name_tr": "Polietilen Tablalı Çalışma Tezgahı Taban Rafsız",
          "name_en": "Worktable with Polyethylene Top without Bottom Shelf",
          "slug": "polietilen-tablali-calisma-tezgahi-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/polietilen-tablali-calisma-tezgahi-taban-rafsiz/P.PTÇT.60.01_Polietilen_Tablalı_Çalışma_Tezgahı_Taban_Rafsız_600x600x850_mm.jpg"
      },
      {
          "id": 39,
          "name_tr": "Polietilen Çalışma Tezgahı Et Kütüğü",
          "name_en": "Polyethylene Worktable Chopping Block",
          "slug": "polietilen-calisma-tezgahi-et-kutugu",
          "imageUrl": "/profinoks/products/tezgahlar/polietilen-calisma-tezgahi-et-kutugu/P.PTÇTE.60.01_Polietilen_Çalışma_Tezgahı_Et_Kütüğü_600x600x850_mm.jpg"
      },
      {
          "id": 40,
          "name_tr": "Sebze Süzme Tezgahı",
          "name_en": "Vegetable Draining Table",
          "slug": "sebze-suzme-tezgahi",
          "imageUrl": "/profinoks/products/tezgahlar/sebze-suzme-tezgahi/P.SST.60.01_Sebze_Süzme_Tezgahı_1000x600x850_mm.jpg"
      },
      {
          "id": 41,
          "name_tr": "Tek Evyeli Çalışma Tezgahı Sırtlı Taban Raflı",
          "name_en": "Single Sink Worktable with Upstand & Bottom Shelf",
          "slug": "tek-evyeli-calisma-tezgahi-sirtli-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/tek-evyeli-calisma-tezgahi-sirtli-taban-rafli/P.TTE.60.01_Tek_Evyeli_400x400x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_600x600x850_mm.jpg"
      },
      {
          "id": 42,
          "name_tr": "Tek Evyeli Çalışma Tezgahı Sırtlı Taban Rafsız",
          "name_en": "Single Sink Worktable with Upstand without Bottom Shelf",
          "slug": "tek-evyeli-calisma-tezgahi-sirtli-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/tek-evyeli-calisma-tezgahi-sirtli-taban-rafsiz/P.TE.60.01_Tek_Evyeli_400x400x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_600x600x850_mm.jpg"
      },
      {
          "id": 43,
          "name_tr": "Temizlik Ekipman Dolabı",
          "name_en": "Cleaning Equipment Cabinet",
          "slug": "temizlik-ekipman-dolabi",
          "imageUrl": "/profinoks/products/tezgahlar/temizlik-ekipman-dolabi/P.TED.40.01_Temizlik_Ekipman_Dolabı_1000x400x1600_mm.jpg"
      },
      {
          "id": 44,
          "name_tr": "Çalışma Tezgahı Ara ve Taban Raflı",
          "name_en": "Worktable with Intermediate and Bottom Shelf",
          "slug": "calisma-tezgahi-ara-ve-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-ara-ve-taban-rafli/P.ÇTTA.60.01_Çalışma_Tezgahı_Ara_ve_Taban_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 45,
          "name_tr": "Çalışma Tezgahı Blok Çekmece Modülü",
          "name_en": "Worktable Drawer Block Module",
          "slug": "calisma-tezgahi-blok-cekmece-modulu",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmece-modulu/P.BÇEK.60.01_Çalışma_Tezgahı_Üçlü_Blok_Çekmece_Modülü_600x600x700_mm.jpg"
      },
      {
          "id": 46,
          "name_tr": "Çalışma Tezgahı Blok Çekmeceli Taban Raflı",
          "name_en": "Worktable with Drawer Block & Bottom Shelf",
          "slug": "calisma-tezgahi-blok-cekmeceli-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-taban-rafli/P.ÇTBÇ.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Taban_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 47,
          "name_tr": "Çalışma Tezgahı Blok Çekmeceli Taban Rafsız",
          "name_en": "Worktable with Drawer Block without Bottom Shelf",
          "slug": "calisma-tezgahi-blok-cekmeceli-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-taban-rafsiz/P.ÇBÇ.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Taban_Rafsız_900x600x850_mm.jpg"
      },
      {
          "id": 48,
          "name_tr": "Çalışma Tezgahı Blok Çekmeceli Taban ve Ara Raflı",
          "name_en": "Worktable with Drawer Block, Bottom and Intermediate Shelf",
          "slug": "calisma-tezgahi-blok-cekmeceli-taban-ve-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-taban-ve-ara-rafli/P.ÇTTBÇ.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Taban_ve_Ara_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 49,
          "name_tr": "Çalışma Tezgahı Blok Çekmeceli Çarpma Kapılı Taban Raflı",
          "name_en": "Worktable with Drawer Block, Hinged Door & Bottom Shelf",
          "slug": "calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-rafli/P.ÇÇTB.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Çarpma_Kapılı_Taban_Raflı_1100x600x850_mm.jpg"
      },
      {
          "id": 50,
          "name_tr": "Çalışma Tezgahı Blok Çekmeceli Çarpma Kapılı Taban ve Ara Raflı",
          "name_en": "Worktable with Drawer Block, Hinged Door, Bottom and Intermediate Shelf",
          "slug": "calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-ve-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-blok-cekmeceli-carpma-kapili-taban-ve-ara-rafli/P.ÇÇAB.60.01_Çalışma_Tezgahı_Blok_Çekmeceli_Çarpma_Kapılı_Taban_Raflı_1100x600x850_mm.jpg"
      },
      {
          "id": 51,
          "name_tr": "Çalışma Tezgahı Köşe Ünitesi Sırtlı Taban Raflı",
          "name_en": "Corner Worktable Unit with Upstand and Bottom Shelf",
          "slug": "calisma-tezgahi-kose-unitesi-sirtli-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-kose-unitesi-sirtli-taban-rafli/P.ÇTKT.60.01_Çalışma_Tezgahı_Köşe_Ünitesi_Sırtlı_Taban_Raflı_600x600x850_mm.jpg"
      },
      {
          "id": 52,
          "name_tr": "Çalışma Tezgahı Köşe Ünitesi Sırtlı Taban Rafsız",
          "name_en": "Corner Worktable Unit with Upstand without Bottom Shelf",
          "slug": "calisma-tezgahi-kose-unitesi-sirtli-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-kose-unitesi-sirtli-taban-rafsiz/P.ÇTK.60.01_Çalışma_Tezgahı_Köşe_Ünitesi_Sırtlı_Taban_Rafsız_600x600x850_mm.jpg"
      },
      {
          "id": 53,
          "name_tr": "Çalışma Tezgahı Köşe Ünitesi Sırtlı Taban ve Ara Raflı",
          "name_en": "Corner Worktable Unit with Upstand, Bottom and Intermediate Shelf",
          "slug": "calisma-tezgahi-kose-unitesi-sirtli-taban-ve-ara-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-kose-unitesi-sirtli-taban-ve-ara-rafli/P.ÇTKTA.60.01_Çalışma_Tezgahı_Köşe_Ünitesi_Sırtlı_Taban_ve_Ara_Raflı_600x600x850_mm.jpg"
      },
      {
          "id": 54,
          "name_tr": "Çalışma Tezgahı Sırtlı Dörtlü Blok Çekmeceli Ünite",
          "name_en": "Worktable with Upstand & 4-Drawer Block Unit",
          "slug": "calisma-tezgahi-sirtli-dortlu-blok-cekmeceli-unite",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-dortlu-blok-cekmeceli-unite/P.ÇT4BU.60.01_Çalışma_Tezgahı_Sırtlı_Dörtlü_Blok_Çekmeceli_Ünite_600x600x850_mm.jpg"
      },
      {
          "id": 55,
          "name_tr": "Çalışma Tezgahı Sırtlı Taban Raflı",
          "name_en": "Worktable with Upstand & Bottom Shelf",
          "slug": "calisma-tezgahi-sirtli-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-taban-rafli/P.ÇTT.60.01_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_900x600x850_mm.jpg"
      },
      {
          "id": 56,
          "name_tr": "Çalışma Tezgahı Sırtlı Taban Rafsız",
          "name_en": "Worktable with Upstand without Bottom Shelf",
          "slug": "calisma-tezgahi-sirtli-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-taban-rafsiz/P.ÇT.60.01_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_900x600x850_mm.jpg"
      },
      {
          "id": 57,
          "name_tr": "Çalışma Tezgahı Sırtlı Üçlü Blok Çekmeceli Ünite",
          "name_en": "Worktable with Upstand & 3-Drawer Block Unit",
          "slug": "calisma-tezgahi-sirtli-uclu-blok-cekmeceli-unite",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-sirtli-uclu-blok-cekmeceli-unite/P.ÇT3BU.60.01_Çalışma_Tezgahı_Sırtlı_Üçlü_Blok_Çekmeceli_Ünite_600x600x850_mm.jpg"
      },
      {
          "id": 58,
          "name_tr": "Çalışma Tezgahı Çekmece Modülü",
          "name_en": "Worktable Drawer Module",
          "slug": "calisma-tezgahi-cekmece-modulu",
          "imageUrl": "/profinoks/products/tezgahlar/calisma-tezgahi-cekmece-modulu/P.TÇEK.60.01_Çalışma_Tezgahı_Çekmece_Modülü_140-600_Seri_534x558x141_mm.jpg"
      },
      {
          "id": 59,
          "name_tr": "Çöp Sıyırma Tezgahı",
          "name_en": "Waste Scraping Table",
          "slug": "cop-siyirma-tezgahi",
          "imageUrl": "/profinoks/products/tezgahlar/cop-siyirma-tezgahi/P.ÇST.70.01_Çöp_Sıyırma_Tezgahı_1100x700x850_mm.jpg"
      },
      {
          "id": 60,
          "name_tr": "Üç Evyeli Çalışma Tezgahı Sırtlı Taban Raflı",
          "name_en": "Triple Sink Worktable with Upstand & Bottom Shelf",
          "slug": "uc-evyeli-calisma-tezgahi-sirtli-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/uc-evyeli-calisma-tezgahi-sirtli-taban-rafli/P.TT3E.60.01_Üç_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_1900x600x850_mm.jpg"
      },
      {
          "id": 61,
          "name_tr": "Üç Evyeli Çalışma Tezgahı Sırtlı Taban Rafsız",
          "name_en": "Triple Sink Worktable with Upstand without Bottom Shelf",
          "slug": "uc-evyeli-calisma-tezgahi-sirtli-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/uc-evyeli-calisma-tezgahi-sirtli-taban-rafsiz/P.T3E.60.01_Üç_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_1900x600x850_mm.jpg"
      },
      {
          "id": 62,
          "name_tr": "İki Evyeli Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Sürgü Kapılı",
          "name_en": "Double Sink Cupboard Worktable with Upstand, Sliding Doors without Intermediate Shelf",
          "slug": "iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili",
          "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-surgu-kapili/P.DÇS2E.60.01_İki_Evyeli_400x400x250_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Sürgü_Kapılı_1200x600x850_mm.jpg"
      },
      {
          "id": 63,
          "name_tr": "İki Evyeli Dolaplı Çalışma Tezgahı Sırtlı Ara Rafsız Çarpma Kapılı",
          "name_en": "Double Sink Cupboard Worktable with Upstand, Hinged Doors without Intermediate Shelf",
          "slug": "iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili",
          "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-dolapli-calisma-tezgahi-sirtli-ara-rafsiz-carpma-kapili/P.DÇÇ2E.60.01_İki_Evyeli_400x400x250_Dolaplı_Çalışma_Tezgahı_Sırtlı_Ara_Rafsız_Çarpma_Kapılı_1200x600x850_mm.jpg"
      },
      {
          "id": 64,
          "name_tr": "İki Evyeli Çalışma Tezgahı Sırtlı Taban Raflı",
          "name_en": "Double Sink Worktable with Upstand & Bottom Shelf",
          "slug": "iki-evyeli-calisma-tezgahi-sirtli-taban-rafli",
          "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-calisma-tezgahi-sirtli-taban-rafli/P.TT2E.60.01_İki_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Raflı_1200x600x850_mm.jpg"
      },
      {
          "id": 65,
          "name_tr": "İki Evyeli Çalışma Tezgahı Sırtlı Taban Rafsız",
          "name_en": "Double Sink Worktable with Upstand without Bottom Shelf",
          "slug": "iki-evyeli-calisma-tezgahi-sirtli-taban-rafsiz",
          "imageUrl": "/profinoks/products/tezgahlar/iki-evyeli-calisma-tezgahi-sirtli-taban-rafsiz/P.T2E.60.01_İki_Evyeli_400x500x250_Evyeli_Çalışma_Tezgahı_Sırtlı_Taban_Rafsız_1200x600x850_mm.jpg"
      }
  ],
  "istif-raflari": [
    { id: 1101, name_tr: "Düz Raflar", name_en: "Flat Shelves", slug: "duz-raflar", imageUrl: "/profinoks/products/istif-raflari/duz-raflar/3 Katlı Paslanmaz Düz Raf - INOX 304.jpg" },
    { id: 1102, name_tr: "Perfore Raflar", name_en: "Perforated Shelves", slug: "perfore-raflar", imageUrl: "/profinoks/products/istif-raflari/perfore-raflar/3 Katlı Paslanmaz Perfore Raf - INOX 304.jpg" },
    { id: 1103, name_tr: "Plastik Raflar", name_en: "Plastic Shelves", slug: "plastik-raflar", imageUrl: "/profinoks/products/istif-raflari/plastik-raflar/3 Katlı Plastik Paslanmaz Raf - 304 Kalite Şase.jpg" },
    { id: 1104, name_tr: "Raf Ekipmanları", name_en: "Shelf Equipment", slug: "raf-ekipmanlari", imageUrl: "/profinoks/products/istif-raflari/raf-ekipmanlari/Paslanmaz Düz Raf Tablası - INOX 304.jpg" },
    { id: 1105, name_tr: "Tel Raflar", name_en: "Wire Shelves", slug: "tel-raflar", imageUrl: "/profinoks/products/istif-raflari/tel-raflar/3 Katlı Paslanmaz Krom Tel Raf - INOX 304.jpg" },
    { id: 1106, name_tr: "Üstü Delikli Plastik Paletler", name_en: "Perforated Plastic Pallets", slug: "ustu-delikli-plastik-paletler", imageUrl: "/profinoks/products/istif-raflari/ustu-delikli-plastik-paletler/100x120 cm Üstü Delikli Palet - 1012-KSMA.jpg" },
    { id: 1107, name_tr: "Üstü Kapalı Plastik Paletler", name_en: "Closed Top Plastic Pallets", slug: "ustu-kapali-plastik-paletler", imageUrl: "/profinoks/products/istif-raflari/ustu-kapali-plastik-paletler/100x120 cm Plastik Ağır Yük Paleti - 1012-PVP.jpg" },
  ],
  "yer-izgaralari": [
    { id: 1, name_tr: "Yer Izgarası", name_en: "Floor Drain", imageUrl: "/profinoks/products/yer-izgaralari.jpg" },
  ],
  "davlumbazlar": [
    { id: 1, name_tr: "Davlumbaz", name_en: "Hood", imageUrl: "/profinoks/products/davlumbazlar.jpg" },
  ],
  "mutfak-arabalari": [
    { id: 1, name_tr: "Taşıma Arabaları", name_en: "Transport Trolleys", imageUrl: "/profinoks/products/mutfak-arabalari/P.SRA.10.02 Servis Arabası Üç Katlı 800x600x950 mm..jpg" },
  ],
  "yardimci-mutfak-ekipmanlari": [
    { id: 1, name_tr: "Yardımcı Mutfak Ekipmanları", name_en: "Auxiliary Kitchen Equipment", imageUrl: "/profinoks/products/yardimci-mutfak-ekipmanlari.jpg" },
  ],
  "horeca-setustu": [
        {
            "id": 1,
            "name_tr": "Ahşap Grubu",
            "name_en": "Wooden Group",
            "slug": "ahsap-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/ahsap-grubu.jpg"
        },
        {
            "id": 2,
            "name_tr": "Akrilik Grubu",
            "name_en": "Acrylic Group",
            "slug": "akrilik-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/akrilik-grubu.jpg"
        },
        {
            "id": 3,
            "name_tr": "Açık Büfe Ekipmanları",
            "name_en": "Open Buffet Equipment",
            "slug": "acik-bufe-ekipmanlari",
            "imageUrl": "/profinoks/products/horeca-setustu/acik-bufe-ekipmanlari.jpg"
        },
        {
            "id": 4,
            "name_tr": "Açık Büfe Teşhir",
            "name_en": "Open Buffet Display",
            "slug": "acik-bufe-teshir",
            "imageUrl": "/profinoks/products/horeca-setustu/acik-bufe-teshir/AL-72401-1_Döner_Sosluk_Reçellik_Standı_-_72_li_3006-5006_Model.jpg"
        },
        {
            "id": 5,
            "name_tr": "Bakır Grubu",
            "name_en": "Copper Group",
            "slug": "bakir-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/bakir-grubu.jpg"
        },
        {
            "id": 6,
            "name_tr": "Bıçaklar",
            "name_en": "Knives",
            "slug": "bicaklar",
            "imageUrl": "/profinoks/products/horeca-setustu/bicaklar.jpg"
        },
        {
            "id": 7,
            "name_tr": "Cam Grubu",
            "name_en": "Glass Group",
            "slug": "cam-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu.jpg"
        },
        {
            "id": 8,
            "name_tr": "Döküm Grubu",
            "name_en": "Cast Iron Group",
            "slug": "dokum-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/dokum-grubu.jpg"
        },
        {
            "id": 35,
            "name_tr": "Altınbaşak Döküm",
            "name_en": "Altınbaşak Cast Iron",
            "slug": "dokum-grubu/dokum-altinbasak-dokum",
            "imageUrl": "/profinoks/products/horeca-setustu/dokum-grubu/altinbasak-dokum.jpg",
            "parent": "dokum-grubu"
        },
        {
            "id": 9,
            "name_tr": "Masaüstü Ekipmanları",
            "name_en": "Tabletop Equipment",
            "slug": "masaustu-ekipmanlari",
            "imageUrl": "/profinoks/products/horeca-setustu/masaustu-ekipmanlari.jpg"
        },
        {
            "id": 10,
            "name_tr": "Melamin Grubu",
            "name_en": "Melamine Group",
            "slug": "melamin-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/melamin-grubu.jpg"
        },
        {
            "id": 11,
            "name_tr": "Pişirme Ekipmanları",
            "name_en": "Cooking Equipment",
            "slug": "pisirme-ekipmanlari",
            "imageUrl": "/profinoks/products/horeca-setustu/pisirme-ekipmanlari.jpg"
        },
        {
            "id": 12,
            "name_tr": "Polikarbonat Ürünler",
            "name_en": "Polycarbonate Products",
            "slug": "polikarbonat-urunler",
            "imageUrl": "/profinoks/products/horeca-setustu/polikarbonat-urunler.jpg"
        },
        {
            "id": 13,
            "name_tr": "Porselen Grubu",
            "name_en": "Porcelain Group",
            "slug": "porselen-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu.jpg"
        },
        {
            "id": 14,
            "name_tr": "Bonna Porselen",
            "name_en": "Bonna Porcelain",
            "slug": "porselen-grubu/bonna-porselen",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/bonna.jpg"
        },
        {
            "id": 15,
            "name_tr": "By Bone Porselen",
            "name_en": "By Bone Porcelain",
            "slug": "porselen-grubu/by-bone-porselen",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/by-bone.jpg"
        },
        {
            "id": 16,
            "name_tr": "Güral Porselen",
            "name_en": "Güral Porcelain",
            "slug": "porselen-grubu/gural-porselen",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/gural.jpg"
        },
        {
            "id": 17,
            "name_tr": "ID Fine Porselen",
            "name_en": "ID Fine Porcelain",
            "slug": "porselen-grubu/id-fine-porselen",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/id-fine.jpg"
        },
        {
            "id": 18,
            "name_tr": "Jumbo Porselen",
            "name_en": "Jumbo Porcelain",
            "slug": "porselen-grubu/jumbo-porselen",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/jumbo-porselen.jpg"
        },
        {
            "id": 19,
            "name_tr": "Kütahya Porselen",
            "name_en": "Kütahya Porcelain",
            "slug": "porselen-grubu/kutahya-porselen",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/kutahya-porselen.jpg"
        },
        {
            "id": 20,
            "name_tr": "Porland Porselen",
            "name_en": "Porland Porcelain",
            "slug": "porselen-grubu/porland-porselen",
            "imageUrl": "/profinoks/products/horeca-setustu/porselen-grubu/porland-porselen.jpg"
        },
        {
            "id": 21,
            "name_tr": "Toprak Grubu",
            "name_en": "Earthenware & Clay Group",
            "slug": "toprak-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/toprak-grubu.jpg"
        },
        {
            "id": 22,
            "name_tr": "Çatal, Bıçak & Kaşık Grubu",
            "name_en": "Cutlery & Flatware Group",
            "slug": "catal-bicak-kasik-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu.jpg"
        },
        {
            "id": 23,
            "name_tr": "Hisar Çatal, Bıçak & Kaşık",
            "name_en": "Hisar Cutlery",
            "slug": "catal-bicak-kasik-grubu-hisar-catal-bicak-kasik",
            "parent": "catal-bicak-kasik-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/hisar.jpg"
        },
        {
            "id": 24,
            "name_tr": "Kılıçlar Çatal, Bıçak & Kaşık",
            "name_en": "Kılıçlar Cutlery",
            "slug": "catal-bicak-kasik-grubu-kiliclar-catal-bicak-kasik",
            "parent": "catal-bicak-kasik-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/kiliclar.jpg"
        },
        {
            "id": 25,
            "name_tr": "Jumbo Çatal, Bıçak & Kaşık",
            "name_en": "Jumbo Cutlery",
            "slug": "catal-bicak-kasik-grubu-jumbo-catal-bicak-kasik",
            "parent": "catal-bicak-kasik-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/jumbo.jpg"
        },
        {
            "id": 26,
            "name_tr": "Narin Çatal, Bıçak & Kaşık",
            "name_en": "Narin Cutlery",
            "slug": "catal-bicak-kasik-grubu-narin-catal-bicak-kasik",
            "parent": "catal-bicak-kasik-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/catal-bicak-kasik-grubu/narin.jpg"
        },
        {
            "id": 27,
            "name_tr": "Cam Grubu",
            "name_en": "Glass Group",
            "slug": "cam-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu.jpg"
        },
        {
            "id": 28,
            "name_tr": "PAŞABAHÇE",
            "name_en": "PAŞABAHÇE",
            "slug": "cam-grubu-pasabahce",
            "parent": "cam-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu/pasabahce.jpg"
        },
        {
            "id": 29,
            "name_tr": "Nude",
            "name_en": "Nude",
            "slug": "cam-grubu-nude",
            "parent": "cam-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu/nude-koleksiyonu.jpg"
        },
        {
            "id": 30,
            "name_tr": "Lav",
            "name_en": "Lav",
            "slug": "cam-grubu-lav",
            "parent": "cam-grubu",
            "imageUrl": "/profinoks/products/horeca-setustu/cam-grubu/Lav.jpg"
        },
        {
            "id": 31,
            "name_tr": "Altınbaşak",
            "name_en": "Altınbaşak",
            "slug": "pisirme-ekipmanlari/altinbasak",
            "imageUrl": "/profinoks/products/horeca-setustu/pisirme-ekipmanlari/altinbasak.jpg"
        },
        {
            "id": 32,
            "name_tr": "Novac",
            "name_en": "Novac",
            "slug": "pisirme-ekipmanlari/novac",
            "imageUrl": "/profinoks/products/horeca-setustu/pisirme-ekipmanlari/novac.jpg"
        },
        {
            "id": 33,
            "name_tr": "Pirge",
            "name_en": "Pirge",
            "slug": "bicaklar/pirge",
            "imageUrl": "/profinoks/products/horeca-setustu/bicaklar/pirge.jpg"
        },
        {
            "id": 34,
            "name_tr": "Sürbisa",
            "name_en": "Sürbisa",
            "slug": "bicaklar/surbisa",
            "imageUrl": "/profinoks/products/horeca-setustu/bicaklar/surbisa.jpg"
        }
    ],
  "camasirhane-ekipmanlari": [
    { id: 1, name_tr: "Bantlı Silindir Ütü Makinaları", name_en: "Belt Cylinder Ironing Machines", slug: "camasirhane-bantli-silindir-utu-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/bantli-silindir-utu-makinalari/Electrolux_Professional_-_IB5730-F_Bantlı_Silindir_Ütü_Makinesi__700_mm_x_3000_mm.jpg" },
    { id: 2, name_tr: "Hijyenik Bariyerli Çamaşır Yıkama Sıkma Makinaları", name_en: "Hygienic Barrier Washer Extractors", slug: "hijyenik-bariyerli-camasir-yikama-sikma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/hijyenik-bariyerli-camasir-yikama-sikma-makinalari/Electrolux_Professional_WB6-110_Hijyenik_Bariyerli_Çamaşır_Yıkama_Sıkma_Makinesı_110_kg._-_Line_6000_seri.jpg" },
    { id: 3, name_tr: "Kombi Çamaşır Yıkama Sıkma Kurutma Makinaları", name_en: "Combined Washer Dryers", slug: "kombi-camasir-yikama-sikma-kurutma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/kombi-camasir-yikama-sikma-kurutma-makinalari/PRF-KÇYSKME_4.0.2020_Kombi_Çamaşır_Yıkama_Sıkma_Kurutma_Makinası_2020_Kg..jpg" },
    { id: 4, name_tr: "Kurutma Dolapları", name_en: "Drying Cabinets", slug: "kurutma-dolapları", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/kurutma-doplari/Electrolux_Professional_-_DC6-10HP_Kurutma_Dolabı_1395_mm..jpg" },
    { id: 5, name_tr: "Paskala Ütüler", name_en: "Ironing Boards (Paskala)", slug: "paskala-utuler", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/paskala-utuler/PRF-PÜM_0022_Kendinden_Kazanlı_Paskala_Ütü_Makinası_140_x_45_x_90_cm.jpg" },
    { id: 6, name_tr: "Pres Ütüler", name_en: "Press Irons", slug: "pres-utuler", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/pres-utuler/PRF-PÜM_0021_Endüstriyel_Tip_Pres_Ütü_Makinası_145_x_135_x_145_cm.jpg" },
    { id: 7, name_tr: "Çamaşır Kurutma Makinaları", name_en: "Laundry Drying Machines", slug: "camasirhane-camasir-kurutma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/camasir-kurutma-makinalari/Electrolux_Professional_-_myPRO_-_TE1120HP_Yarı_Endüstriyel_Kurutma_Makinesi_8_kg..jpg" },
    { id: 8, name_tr: "Çamaşır Yıkama Sıkma Makinaları", name_en: "Washer Extractors", slug: "camasirhane-camasir-yikama-sikma-makinalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/camasir-yikama-sikma-makinalari/Electrolux_Professional_-_myPRO_-_PDSTP10S_MYPRO_ÇAMAŞIR_YIKAMASIKMA_MAKİNELERİ_İÇİN_ALT_BAZA.jpg" },
    { id: 9, name_tr: "Çamaşırhane Arabaları", name_en: "Laundry Trolleys", slug: "camasirhane-arabalari", imageUrl: "/profinoks/products/camasirhane-ekipmanlari/camasirhane-arabalari/ASKILI_KIYAFET_ARABASI_67_x_152_x_175_cm.jpeg" },
  ],
  "ahsap-urunler": [
    { id: 1, name_tr: "Ahşap Banket Gurubu Tepsi Arabaları", name_en: "Wooden Banquet Tray Trolleys", slug: "ahsap-banket-gurubu-tepsi-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Banket Gurubu Tepsi Arabaları/PRF.1755 Tepsi Arabası Ölçüler En 46 cm  Boy 63 cm  Yükseklik 163 cm.png" },
    { id: 2, name_tr: "Ahşap Flambe Arabaları", name_en: "Wooden Flambe Trolleys", slug: "ahsap-flambe-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Flambe Arabaları/PRF.106 Flambé Arabası – Profesyonel Ölçüler En 60 cm  Boy 117 cm  Yükseklik 92 cm.png" },
    { id: 3, name_tr: "Ahşap Kat Arabaları", name_en: "Wooden Housekeeping Trolleys", slug: "ahsap-kat-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Kat Arabaları/PRF.1410 K Kat Arabası (Kapaklı) Ölçüler En 55 cm  Boy 145 cm  Yükseklik 130 cm.png" },
    { id: 4, name_tr: "Ahşap Oda Servis Arabaları", name_en: "Wooden Room Service Trolleys", slug: "ahsap-oda-servis-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Oda Servis Arabaları/PRF.1455-P Isıtma Kutusu İstasyonu (Paslanmaz Çelik) Ölçüler En 49 cm  Boy 100 cm  Yükseklik 150 cm.png" },
    { id: 5, name_tr: "Ahşap Servantlar", name_en: "Wooden Sideboards", slug: "ahsap-servantlar", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Servantlar/PRF.1740 Boş Toplama Arabası Ölçüler En 61 Boy 120 Yükseklik 88 cm.png" },
    { id: 6, name_tr: "Ahşap Servis Arabaları", name_en: "Wooden Service Trolleys", slug: "ahsap-servis-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Ahşap Servis Arabaları/PRF.101 Servis Arabası ÖlçülerE55 B 100 Y90 cm.png" },
    { id: 8, name_tr: "Pasta Teşhir ve Servis Arabaları", name_en: "Cake Display and Service Trolleys", slug: "pasta-teshir-ve-servis-arabalari", imageUrl: "/profinoks/products/ahsap-urunler/Pasta Teşhir ve Servis Arabaları/PRF.103.MS Peynir & Tatlı Arabası (Motor Soğutmalı) Ölçüler En 50 cm  Boy 100 cm  Yükseklik 108 cm.png" },
    { id: 9, name_tr: "Saladbarlar", name_en: "Salad Bars", slug: "saladbarlar", imageUrl: "/profinoks/products/ahsap-urunler/Saladbarlar/PRF.130 SALADBAR ( Üstü Kapaklı) Ölçüler En 70 Boy 155 Yükseklik 90+40 cm.jpg" },
  ],
  "firin-makineleri": [
    { id: 1, name_tr: "Borulu Pişirme Fırını", name_en: "Tube Baking Oven", imageUrl: "/profinoks/products/firin-makineleri/BORULU_PISIRME_FIRINLARI.jpg" },
  ],
  "electrolux-professional": [
    { id: 1, name_tr: "700XP Pişiriciler", name_en: "700XP Cooking Equipment", slug: "700xp-pisiriciler", imageUrl: "/profinoks/products/electrolux-professional/700XP Pişiriciler/Griller & Izgaralar/371037 - 700XP Gazlı set üstü ızgara, düz krom pleytli, - 400x730x250 mm.jpg" },
    { id: 2, name_tr: "900XP Pişiriciler", name_en: "900XP Cooking Equipment", slug: "900xp-pisiriciler", imageUrl: "/profinoks/products/electrolux-professional/900XP Pişiriciler/Griller & Izgaralar/391053 - 900XP Gazlı set üstü ızgara (10kW), düz krom pleytli, eğimli tablalı, termostatik kontrol, demonte sırtlık ve spatula - 400x930x250 mm.jpg" },
  ],
};
